import { FC, JSX } from 'react';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// interfaces
import { DashboardStatsChart, TopContributorColorType, IconProps } from 'interfaces';

export const SupplierIcon: JSX.Element = <LocalShippingIcon />;

export const ExcipientIcon: JSX.Element = (
  <svg width="22" height="22" viewBox="0 0 512 512">
    <g>
      <path d="M512,212.638l-0.567-8.278c-0.917-13.359-12.457-23.472-25.824-22.618H26.399   c-13.367-0.853-24.916,9.26-25.833,22.618L0,212.638c10.456,94.541,72.09,173.602,156.558,209.005l-3.597,27.603   c-2.863,19.077-5.726,31.479,25.761,31.479h149.092c31.479,0,28.617-12.402,25.761-31.479l-3.317-25.442   C437.398,389.526,501.328,309.109,512,212.638z" />
      <path d="M458.948,87.536c8.23-17.282,0.9-37.955-16.382-46.186l-14.076-6.699c-17.275-8.23-37.939-0.894-46.17,16.381   l-54.082,113.539h94.022L458.948,87.536z" />
    </g>
  </svg>
);

export const SmallDotIcon: JSX.Element = (
  <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="2" cy="2" r="2" transform="matrix(1 0 0 -1 0 4)" fill="#637381" />
  </svg>
);

export const EditIcon: FC = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.75 4.39293L10.6352 1.27105C10.4254 1.05598 10.1408 0.930063 9.84062 0.919488C9.68827 0.915979 9.53679 0.943462 9.39537 1.00027C9.25396 1.05708 9.12556 1.14202 9.01797 1.24996L7.16172 3.09918L0.580469 9.68746C0.475632 9.7915 0.392449 9.91528 0.335728 10.0517C0.279006 10.188 0.249869 10.3343 0.25 10.482V13.625C0.25 13.9233 0.368527 14.2095 0.579505 14.4205C0.790484 14.6314 1.07663 14.75 1.375 14.75H4.51797C4.81599 14.7487 5.10148 14.6299 5.3125 14.4195L13.75 5.98199C13.9587 5.77019 14.0757 5.48479 14.0757 5.18746C14.0757 4.89012 13.9587 4.60472 13.75 4.39293ZM11.5 6.64292L8.35703 3.49996L9.8125 2.04449L12.9555 5.18746L11.5 6.64292Z"
        fill="#3366FF"
      />
    </svg>
  );
};

export const FileUploadIcon: FC = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 8C3.5 8.55 3.95 9 4.5 9C5.05 9 5.5 8.55 5.5 8V6H7.5C8.05 6 8.5 5.55 8.5 5C8.5 4.45 8.05 4 7.5 4H5.5V2C5.5 1.45 5.05 1 4.5 1C3.95 1 3.5 1.45 3.5 2V4H1.5C0.95 4 0.5 4.45 0.5 5C0.5 5.55 0.95 6 1.5 6H3.5V8Z"
        fill="#637381"
      />
      <circle cx="13.5" cy="14" r="3" fill="#637381" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.33 6H21.5C22.6 6 23.5 6.9 23.5 8V20C23.5 21.1 22.6 22 21.5 22H5.5C4.4 22 3.5 21.1 3.5 20V9.72C3.8 9.89 4.13 10 4.5 10C5.6 10 6.5 9.1 6.5 8V7H7.5C8.6 7 9.5 6.1 9.5 5C9.5 4.63 9.39 4.3 9.22 4H15.62C16.18 4 16.72 4.24 17.09 4.65L18.33 6ZM8.5 14C8.5 16.76 10.74 19 13.5 19C16.26 19 18.5 16.76 18.5 14C18.5 11.24 16.26 9 13.5 9C10.74 9 8.5 11.24 8.5 14Z"
        fill="#637381"
      />
    </svg>
  );
};

export const NoDataIcon = (): JSX.Element => {
  return (
    <svg width="217" height="160" viewBox="0 0 217 160" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.2">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 88.347C0 106.772 6.74953 123.562 17.8563 136.252C30.5983 150.814 49.0755 159.969 69.6715 160C78.6728 160.013 87.2796 158.272 95.1854 155.095C99.2731 153.451 103.848 153.64 107.807 155.587C112.451 157.868 117.652 159.147 123.143 159.147C125.411 159.147 127.633 158.928 129.781 158.51C135.915 157.323 141.496 154.515 146.08 150.537C148.96 148.036 152.65 146.779 156.421 146.783H156.485C168.944 146.783 180.518 142.902 190.126 136.252C198.717 130.314 205.731 122.165 210.405 112.596C214.48 104.258 216.774 94.8391 216.774 84.8701C216.774 50.6788 189.779 22.9571 156.485 22.9571C153.09 22.9571 149.765 23.2515 146.521 23.8008C137.931 9.52003 122.548 0 104.999 0C97.5905 0 90.5666 1.69675 84.2794 4.73832C78.3002 7.62148 72.9841 11.7183 68.6354 16.7111C53.869 16.9529 40.2152 21.9066 29.0401 30.174C11.449 43.1801 0 64.3922 0 88.347Z"
          fill="url(#paint0_linear_610_34916)"
        />
      </g>
      <path
        opacity="0.05"
        d="M132.326 91.6407C131.31 92.8286 130.214 92.8087 129.561 92.6412L129.585 92.026C129.585 92.026 132.285 90.8115 132.216 91.0667C132.191 91.1623 132.242 91.3922 132.326 91.6407Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M139.725 92.9853C138.001 93.966 136.99 92.8166 136.755 92.491C136.899 92.1176 137.117 91.5117 137.072 91.339C137.007 91.0825 139.704 92.297 139.704 92.297L139.725 92.9853Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M137.879 83.2017C137.879 83.2017 139.519 82.2716 139.877 82.6901C140.235 83.1087 137.879 83.2017 137.879 83.2017Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M138.87 83.7132C138.87 83.7132 138.6 83.8461 139.195 84.0162C139.791 84.1863 138.87 83.7132 138.87 83.7132Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M128.95 81.1553C128.894 81.1713 130.315 82.0987 131.598 81.3307C131.592 81.3307 129.27 81.0597 128.95 81.1553Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M131.528 82.9293C131.528 82.9293 131.139 83.6813 130.342 83.793C129.545 83.9046 131.528 82.9293 131.528 82.9293Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M136.741 84.561C136.741 84.561 138.61 87.4843 138.252 88.1739C137.894 88.8635 136.741 84.561 136.741 84.561Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M133.054 96.185C133.054 96.3484 133.054 96.5012 133.038 96.6275C132.989 97.2188 131.511 96.9955 131.511 96.9955C130.161 97.1802 129.674 96.5424 129.514 95.9325C129.463 95.7344 129.438 95.5309 129.44 95.3266C129.439 95.2048 129.447 95.0832 129.464 94.9625V94.8416C129.755 94.7552 130.07 94.8187 130.304 95.0104C130.904 95.4901 131.701 95.122 131.701 95.122C131.701 95.122 132.286 95.1698 132.511 95.3612C132.638 95.4688 132.847 95.2097 133.007 94.9625C133.016 95.122 133.031 95.4103 133.04 95.7186C133.051 95.8767 133.054 96.0362 133.054 96.185Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M130.683 96.1505C130.683 96.1505 130.278 96.5411 129.514 95.9379C129.463 95.7398 129.438 95.5362 129.439 95.332C129.83 95.6243 130.553 96.1505 130.683 96.1505Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M133.054 96.185C132.987 96.2356 132.903 96.2568 132.819 96.2437C132.736 96.2307 132.662 96.1844 132.615 96.1159C132.773 95.9979 132.918 95.8644 133.047 95.7173C133.051 95.8767 133.054 96.0362 133.054 96.185Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M136.223 96.4587C136.223 96.6235 136.223 96.7763 136.238 96.9012C136.286 97.4938 137.765 97.2693 137.765 97.2693C139.115 97.4553 139.601 96.8175 139.762 96.2063C139.841 95.8891 139.858 95.5598 139.812 95.2363V95.1154C139.52 95.0305 139.205 95.0937 138.971 95.2841C138.37 95.7638 137.575 95.3957 137.575 95.3957C137.575 95.3957 136.99 95.4449 136.764 95.6362C136.637 95.7439 136.428 95.4847 136.27 95.2376C136.261 95.397 136.245 95.6854 136.235 95.9937C136.224 96.1491 136.222 96.3086 136.223 96.4587Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M138.595 96.4215C138.595 96.4215 139 96.8122 139.763 96.2089C139.814 96.0113 139.839 95.8082 139.838 95.6044C139.447 95.8954 138.723 96.4215 138.595 96.4215Z"
        fill="#FF4842"
      />
      <path
        opacity="0.05"
        d="M136.223 96.4587C136.289 96.5092 136.374 96.5304 136.457 96.5173C136.54 96.5043 136.613 96.458 136.66 96.3896C136.503 96.2718 136.358 96.1382 136.228 95.991C136.224 96.1491 136.222 96.3085 136.223 96.4587Z"
        fill="#FF4842"
      />
      <g opacity="0.05">
        <path
          d="M144.342 47.2306C144.37 47.1695 144.397 47.1084 144.423 47.0486C144.449 46.9888 144.458 46.9556 144.473 46.9077C144.423 47.0129 144.379 47.1207 144.342 47.2306Z"
          fill="#FF4842"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.1707 124.205C70.8435 123.817 70.6935 123.314 70.7562 122.813L76.7159 74.8224L77.2101 70.8361C77.3247 69.9189 78.1127 69.2275 79.0518 69.2204L96.5085 69.1061C97.0106 69.1031 97.4904 68.9011 97.8394 68.5458C98.1885 68.1906 98.3775 67.7119 98.3637 67.2179L98.3569 67.0359C98.3397 66.5376 98.5288 66.0539 98.8808 65.6954C99.2328 65.3369 99.7177 65.1345 100.224 65.1344H118.568C119.598 65.1344 120.433 65.9547 120.435 66.9681C120.435 67.0507 120.43 67.1333 120.419 67.2153C120.349 67.7325 120.505 68.2547 120.849 68.6517C121.194 69.0487 121.693 69.283 122.223 69.2961L139.84 69.7386C140.382 69.7517 140.892 69.9962 141.236 70.4085C141.58 70.8207 141.725 71.36 141.633 71.8859L132.826 122.512L132.66 123.469C132.619 123.713 132.527 123.946 132.39 124.154L71.1707 124.205Z"
        fill="#7F6D41"
      />
      <rect
        width="10.2629"
        height="34.6368"
        transform="matrix(0.826958 0.562264 -0.574576 0.818451 124.336 54.967)"
        fill="white"
      />
      <rect
        width="7.24511"
        height="7.20483"
        transform="matrix(0.825354 0.564615 -0.576929 0.816794 124.947 56.3102)"
        fill="#FFC107"
      />
      <rect
        opacity="0.5"
        width="7.25522"
        height="7.21427"
        transform="matrix(0.826958 0.562264 -0.574576 0.818451 120.263 63.4021)"
        fill="#FFC107"
      />
      <rect
        opacity="0.3"
        width="7.25522"
        height="7.21427"
        transform="matrix(0.826958 0.562264 -0.574576 0.818451 115.257 70.5307)"
        fill="#FFC107"
      />
      <rect
        width="10.3027"
        height="34.3699"
        transform="matrix(0.961046 0.276389 -0.28466 0.958629 112.345 53.1916)"
        fill="white"
      />
      <rect
        width="7.28338"
        height="7.18584"
        transform="matrix(0.961046 0.276389 -0.284659 0.958629 113.645 54.1427)"
        fill="#FF4842"
      />
      <rect
        opacity="0.5"
        width="7.28338"
        height="7.18584"
        transform="matrix(0.961046 0.276389 -0.28466 0.958629 111.175 62.459)"
        fill="#FF4842"
      />
      <rect
        opacity="0.3"
        width="7.28338"
        height="7.18584"
        transform="matrix(0.961046 0.27639 -0.284659 0.958629 108.705 70.774)"
        fill="#FF4842"
      />
      <rect
        width="10.3145"
        height="34.3296"
        transform="matrix(0.99688 0.0789339 -0.081484 0.996675 105.331 53.7111)"
        fill="white"
      />
      <rect
        width="7.29168"
        height="7.17741"
        transform="matrix(0.99688 0.0789339 -0.081484 0.996675 106.795 54.384)"
        fill="#1890FF"
      />
      <rect
        opacity="0.5"
        width="7.29167"
        height="7.17741"
        transform="matrix(0.99688 0.0789339 -0.0814839 0.996675 106.088 63.0185)"
        fill="#1890FF"
      />
      <rect
        opacity="0.3"
        width="7.29167"
        height="7.17741"
        transform="matrix(0.99688 0.0789339 -0.0814839 0.996675 105.382 71.6557)"
        fill="#1890FF"
      />
      <rect
        width="10.3152"
        height="34.3272"
        transform="matrix(0.998995 -0.044816 0.0462703 0.998929 100.705 55.0868)"
        fill="white"
      />
      <rect
        width="7.29218"
        height="7.17691"
        transform="matrix(0.998995 -0.044816 0.0462703 0.998929 102.241 55.5716)"
        fill="#B3995B"
      />
      <rect
        opacity="0.5"
        width="7.30124"
        height="7.18592"
        transform="matrix(0.998792 -0.0491469 0.050741 0.998712 102.928 63.9523)"
        fill="#B3995B"
      />
      <rect
        opacity="0.3"
        width="7.29218"
        height="7.17691"
        transform="matrix(0.998995 -0.044816 0.0462703 0.998929 103.043 72.8821)"
        fill="#B3995B"
      />
      <path
        d="M105.081 100.323L95.9156 103.812L82.5203 108.908C82.014 107.978 81.2687 106.721 80.3465 105.221C77.1735 100.046 71.9239 91.998 67.2496 84.925C61.9838 76.9524 57.4512 70.2249 57.4512 70.2249L60.7322 69.2947L87.5336 61.6371L105.081 100.323Z"
        fill="#F4F6F8"
      />
      <path
        opacity="0.1"
        d="M105.081 100.323L95.9155 103.812C90.7956 104.862 85.5709 105.334 80.3423 105.221C77.1694 100.046 71.9198 91.998 67.2454 84.925L60.7334 69.2894L87.5335 61.6371L105.081 100.323Z"
        fill="black"
      />
      <path
        d="M111.9 98.1516C111.9 98.1516 97.6618 106.44 76.4043 104.566L59.458 63.9054L67.5794 62.5314L95.6554 57.7864L111.588 97.361L111.9 98.1516Z"
        fill="#B3995B"
      />
      <path
        opacity="0.1"
        d="M111.582 97.3663C108.229 97.5284 104.35 97.5124 100.448 97.054C96.2249 96.565 91.9772 95.5578 88.3357 93.7108C85.291 92.1681 82.6878 90.4899 80.4181 88.4768C74.5137 83.2508 70.8601 75.7752 67.5791 62.5367L95.6551 57.7916L111.582 97.3663Z"
        fill="#FF4842"
      />
      <path
        d="M122.027 95.0928C122.027 95.0928 111.532 97.1152 100.849 95.8702C96.6258 95.3812 92.378 94.374 88.7366 92.527C85.6919 90.9843 83.09 89.306 80.819 87.293C73.5117 80.8232 69.6529 70.908 65.6738 50.8848C65.6738 50.8848 83.1211 55.0292 100.374 45.9511C100.369 45.9577 106.184 81.6723 122.027 95.0928Z"
        fill="white"
      />
      <path
        opacity="0.3"
        d="M74.6992 58.2355C74.6992 58.2355 88.8871 57.4462 92.8486 54.4365L93.4494 56.3367C93.4494 56.3367 84.075 60.4067 74.6992 60.4559V58.2355Z"
        fill="#B3995B"
      />
      <path
        opacity="0.3"
        d="M74.6992 67.6166C74.6992 67.6166 88.4361 66.8764 98.8151 61.9427L99.1661 62.732C99.1661 62.732 90.9299 67.4638 74.6992 68.7022L74.6992 67.6166Z"
        fill="#B3995B"
      />
      <path
        opacity="0.3"
        d="M75.8047 71.272C75.8047 71.272 89.5416 70.5319 99.9192 65.5982L100.27 66.3875C100.27 66.3875 92.0341 71.1179 75.8047 72.3576L75.8047 71.272Z"
        fill="#B3995B"
      />
      <path
        opacity="0.3"
        d="M76.9092 74.9327C76.9092 74.9327 90.6461 74.1926 101.025 69.2589L101.375 70.0482C101.375 70.0482 93.1386 74.7799 76.9092 76.0183L76.9092 74.9327Z"
        fill="#B3995B"
      />
      <path
        opacity="0.3"
        d="M78.0146 78.5935C78.0146 78.5935 91.7516 77.8534 102.129 72.9197L102.48 73.709C102.48 73.709 94.244 78.4407 78.0146 79.6791L78.0146 78.5935Z"
        fill="#B3995B"
      />
      <path
        opacity="0.3"
        d="M79.1191 82.2556C79.1191 82.2556 92.856 81.5155 103.235 76.5818L103.585 77.371C103.585 77.371 95.3485 82.1014 79.1191 83.3412V82.2556Z"
        fill="#B3995B"
      />
      <path
        d="M175.708 127.709C175.708 127.709 170 127.37 170.672 131.307C170.672 131.307 170.537 132.002 171.18 132.318C171.18 132.318 171.189 132.026 171.765 132.125C171.97 132.159 172.178 132.169 172.386 132.155C172.666 132.136 172.932 132.028 173.143 131.846V131.846C173.143 131.846 174.748 131.194 175.372 128.614C175.372 128.614 175.834 128.05 175.815 127.905L174.852 128.304C174.852 128.304 175.182 128.988 174.923 129.556C174.923 129.556 174.892 128.329 174.707 128.36C174.669 128.36 174.206 128.596 174.206 128.596C174.206 128.596 174.771 129.792 174.341 130.653C174.341 130.653 174.503 129.185 174.025 128.683L173.35 129.072C173.35 129.072 174.011 130.302 173.563 131.307C173.563 131.307 173.678 129.767 173.207 129.166L172.592 129.638C172.592 129.638 173.215 130.851 172.835 131.684C172.835 131.684 172.785 129.89 172.459 129.755C172.459 129.755 171.918 130.221 171.84 130.419C171.84 130.419 172.265 131.299 172.001 131.764C172.001 131.764 171.839 130.568 171.706 130.568C171.706 130.568 171.166 131.365 171.115 131.897C171.115 131.897 171.138 131.089 171.577 130.487C171.268 130.545 170.982 130.691 170.756 130.906C170.756 130.906 170.84 130.345 171.709 130.297C171.709 130.297 172.152 129.696 172.27 129.659C172.27 129.659 171.405 129.589 170.882 129.817C170.882 129.817 171.343 129.286 172.429 129.529L173.035 129.043C173.035 129.043 171.897 128.889 171.415 129.059C171.415 129.059 171.97 128.591 173.198 128.926L173.859 128.538C173.859 128.538 172.889 128.332 172.311 128.405C172.311 128.405 172.92 128.081 174.053 128.431L174.524 128.223C174.524 128.223 173.814 128.09 173.606 128.063C173.398 128.037 173.386 127.986 173.386 127.986C173.836 127.912 174.299 127.962 174.721 128.133C174.721 128.133 175.725 127.771 175.708 127.709Z"
        fill="#B3995B"
      />
      <ellipse opacity="0.1" cx="171.777" cy="132.661" rx="4.03979" ry="0.672356" fill="#B3995B" />
      <path
        d="M178.367 114.712C178.367 114.712 175.149 114.521 175.532 116.741C175.491 116.972 175.606 117.202 175.816 117.311C175.816 117.311 175.823 117.146 176.147 117.202C176.263 117.221 176.38 117.226 176.497 117.218C176.655 117.208 176.804 117.147 176.924 117.045V117.045C176.924 117.045 177.828 116.677 178.181 115.222C178.181 115.222 178.441 114.905 178.43 114.824L177.89 115.051C177.89 115.051 178.075 115.438 177.929 115.758C177.929 115.758 177.912 115.065 177.808 115.081C177.786 115.081 177.526 115.214 177.526 115.214C177.526 115.214 177.844 115.879 177.604 116.374C177.604 116.374 177.696 115.547 177.426 115.262L177.044 115.483C177.044 115.483 177.416 116.176 177.164 116.742C177.164 116.742 177.229 115.873 176.963 115.536L176.617 115.802C176.617 115.802 176.967 116.486 176.752 116.955C176.752 116.955 176.724 115.944 176.54 115.868C176.409 115.978 176.292 116.102 176.19 116.239C176.19 116.239 176.431 116.736 176.282 116.998C176.282 116.998 176.19 116.324 176.116 116.321C176.116 116.321 175.814 116.766 175.783 117.072C175.797 116.788 175.887 116.513 176.043 116.275C175.869 116.307 175.708 116.389 175.58 116.511C175.58 116.511 175.627 116.195 176.12 116.168C176.12 116.168 176.37 115.83 176.436 115.808C176.436 115.808 175.949 115.768 175.653 115.897C175.653 115.897 175.914 115.6 176.525 115.735L176.868 115.46C176.868 115.46 176.226 115.374 175.954 115.469C175.954 115.469 176.267 115.204 176.96 115.398L177.333 115.178C177.046 115.117 176.752 115.092 176.459 115.105C176.459 115.105 176.803 114.922 177.441 115.12L177.711 115.003C177.711 115.003 177.306 114.925 177.192 114.913C177.079 114.901 177.068 114.869 177.068 114.869C177.322 114.827 177.583 114.856 177.821 114.951C177.821 114.951 178.378 114.747 178.367 114.712Z"
        fill="#B3995B"
      />
      <ellipse opacity="0.1" cx="176.153" cy="117.504" rx="2.27779" ry="0.3787" fill="#B3995B" />
      <path
        d="M159.373 116.639C159.373 116.639 155.487 116.407 155.946 119.088C155.897 119.366 156.036 119.644 156.29 119.776C156.29 119.776 156.29 119.577 156.695 119.643C156.835 119.666 156.977 119.673 157.118 119.663C157.309 119.65 157.49 119.577 157.634 119.453V119.453C157.634 119.453 158.726 119.009 159.151 117.253C159.151 117.253 159.466 116.87 159.452 116.77L158.789 117.047C158.789 117.047 159.014 117.512 158.837 117.898C158.837 117.898 158.815 117.064 158.69 117.082C158.664 117.082 158.349 117.245 158.349 117.245C158.349 117.245 158.734 118.055 158.444 118.645C158.444 118.645 158.554 117.646 158.229 117.303L157.767 117.569C157.767 117.569 158.217 118.407 157.912 119.09C157.912 119.09 157.99 118.042 157.67 117.629L157.252 117.95C157.252 117.95 157.676 118.775 157.416 119.343C157.416 119.343 157.384 118.122 157.161 118.03C157.161 118.03 156.795 118.347 156.74 118.478C156.74 118.478 157.029 119.077 156.849 119.393C156.849 119.393 156.738 118.58 156.648 118.576C156.648 118.576 156.285 119.116 156.243 119.484C156.261 119.142 156.37 118.812 156.558 118.524C156.347 118.564 156.153 118.663 156 118.81C156 118.81 156.057 118.429 156.648 118.395C156.648 118.395 156.949 117.986 157.03 117.962C157.03 117.962 156.441 117.913 156.085 118.068C156.085 118.068 156.398 117.71 157.137 117.873L157.55 117.541C157.55 117.541 156.776 117.437 156.447 117.552C156.447 117.552 156.825 117.234 157.662 117.467L158.112 117.201C158.112 117.201 157.451 117.061 157.057 117.112C157.057 117.112 157.473 116.891 158.243 117.13L158.564 116.988C158.564 116.988 158.081 116.895 157.939 116.881C157.797 116.866 157.79 116.827 157.79 116.827C158.097 116.776 158.411 116.81 158.699 116.926C158.699 116.926 159.385 116.68 159.373 116.639Z"
        fill="#B3995B"
      />
      <ellipse opacity="0.1" cx="156.697" cy="120.01" rx="2.75036" ry="0.457092" fill="#B3995B" />
      <rect
        width="22.7133"
        height="41.1756"
        rx="5"
        transform="matrix(0.313683 -0.949528 0.952437 0.304734 125.608 55.5618)"
        fill="white"
      />
      <g opacity="0.2">
        <ellipse cx="137.116" cy="46.0031" rx="4.23422" ry="4.16701" fill="#B3995B" />
      </g>
      <g opacity="0.2">
        <rect
          width="1.14318"
          height="18.42"
          transform="matrix(0.313683 -0.949528 0.952437 0.304734 147.247 45.2529)"
          fill="#B3995B"
        />
      </g>
      <g opacity="0.2">
        <rect
          width="1.14318"
          height="9.38323"
          transform="matrix(0.313683 -0.949528 0.952437 0.304734 146.332 48.0204)"
          fill="#B3995B"
        />
      </g>
      <g opacity="0.2">
        <rect
          width="1.14318"
          height="15.1763"
          transform="matrix(0.313683 -0.949528 0.952437 0.304734 145.417 50.7897)"
          fill="#B3995B"
        />
      </g>
      <g opacity="0.2">
        <rect
          width="1.14318"
          height="18.42"
          transform="matrix(0.313682 -0.949528 0.952437 0.304735 144.503 53.5578)"
          fill="#B3995B"
        />
      </g>
      <g opacity="0.5">
        <rect
          width="2.21051"
          height="5.0974"
          transform="matrix(0.313682 -0.949528 0.952437 0.304735 155.536 62.6283)"
          fill="#B3995B"
        />
      </g>
      <rect
        width="22.4617"
        height="35.2001"
        rx="4"
        transform="matrix(0.546885 -0.837207 0.845079 0.534642 122.01 94.943)"
        fill="white"
      />
      <rect
        width="6.35443"
        height="1.50536"
        transform="matrix(0.542388 -0.840128 0.847895 0.530164 126.418 93.6313)"
        fill="#DFE3E8"
      />
      <rect
        width="13.9557"
        height="1.38036"
        transform="matrix(0.542388 -0.840128 0.847896 0.530163 130.498 94.7127)"
        fill="#DFE3E8"
      />
      <rect
        width="13.9557"
        height="1.38036"
        transform="matrix(0.542388 -0.840128 0.847896 0.530163 132.998 96.2747)"
        fill="#DFE3E8"
      />
      <rect
        width="13.9557"
        height="1.38036"
        transform="matrix(0.542388 -0.840128 0.847896 0.530163 135.497 97.8391)"
        fill="#DFE3E8"
      />
      <rect
        width="13.9372"
        height="1.37832"
        transform="matrix(0.546885 -0.837207 0.845079 0.534642 138.084 100.106)"
        fill="#DFE3E8"
      />
      <rect
        width="13.9557"
        height="1.38036"
        transform="matrix(0.542388 -0.840128 0.847896 0.530163 140.497 100.965)"
        fill="#F4F6F8"
      />
      <rect
        width="13.9557"
        height="1.38036"
        transform="matrix(0.542388 -0.840128 0.847896 0.530163 142.997 102.527)"
        fill="#F4F6F8"
      />
      <rect
        width="3.61375"
        height="3.63839"
        transform="matrix(0.542387 -0.840129 0.847895 0.530164 153.494 95.8664)"
        fill="#DFE3E8"
      />
      <path
        d="M121.609 75.0045L100.94 75.2237C100.166 75.2317 99.5433 75.8509 99.5426 76.6123V78.2932C99.5421 79.047 98.9312 79.663 98.1654 79.6817L83.2512 80.0339C82.6007 80.0499 82.0235 79.6262 81.8537 79.0081L81.1529 76.4741C80.9849 75.8628 80.4178 75.4409 79.7744 75.4483L59.8522 75.6596C59.4391 75.6635 59.0486 75.8455 58.7836 76.1574C58.5186 76.4693 58.4058 76.8798 58.475 77.2807L66.4898 123.702C66.6047 124.369 67.1898 124.857 67.8765 124.86L130.815 125.126C131.236 125.127 131.637 124.943 131.906 124.623C132.175 124.304 132.286 123.883 132.207 123.475L123.009 76.1326C122.881 75.4728 122.291 74.9977 121.609 75.0045V75.0045Z"
        fill="url(#paint1_linear_610_34916)"
      />
      <ellipse opacity="0.1" cx="54.01" cy="114.962" rx="2.18867" ry="0.296318" fill="#B3995B" />
      <ellipse opacity="0.1" cx="45.6262" cy="115.798" rx="2.18867" ry="0.296314" fill="#B3995B" />
      <ellipse opacity="0.1" cx="48.9812" cy="118.18" rx="1.55543" ry="0.209946" fill="#B3995B" />
      <ellipse opacity="0.1" cx="40.281" cy="117.97" rx="1.55543" ry="0.209946" fill="#B3995B" />
      <path
        d="M45.5791 115.733C45.5791 115.733 48.6481 105.831 45.0985 101.864C42.4426 98.8971 39.4276 99.2518 38.0774 99.6186C37.3709 99.8043 36.7826 100.286 36.468 100.935C35.9954 101.937 36.0805 103.564 39.4128 105.462C44.9905 108.641 45.3375 113.001 45.3375 113.001L45.5791 115.733Z"
        fill="#B3995B"
      />
      <path
        d="M38.5596 101.023C38.5596 101.023 47.6059 103.813 45.5806 115.732"
        stroke="#7F6D41"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        d="M43.8443 102.021C43.8443 102.021 42.5981 102.847 42.995 104.09"
        stroke="#7F6D41"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        d="M39.4668 102.757C39.4668 102.757 40.2283 101.994 41.1559 102.416"
        stroke="#7F6D41"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        d="M43.043 106.592C43.043 106.592 44.381 105.928 44.7267 106.761"
        stroke="#7F6D41"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        d="M46.3532 107.983C46.3532 107.983 45.3486 107.905 45.3311 108.382"
        stroke="#7F6D41"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        d="M45.7034 115.811C45.7034 115.811 42.1078 108.614 41.1208 108.768C40.6523 108.844 40.4363 109.3 40.3377 109.754C40.2165 110.344 40.2849 110.956 40.5335 111.506C41.0439 112.662 42.4143 114.848 45.7034 115.811Z"
        fill="#B3995B"
      />
      <path
        d="M41.1475 110.137C41.1475 110.137 44.9199 115.521 45.649 115.758"
        stroke="#7F6D41"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path d="M40.8008 110.978H41.6811" stroke="#7F6D41" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M41.8555 112.947L43.2367 113.006" stroke="#7F6D41" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M42.6967 111.371L42.5469 112.08" stroke="#7F6D41" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M44.164 113.525L44.137 114.169" stroke="#7F6D41" strokeWidth="0.5" strokeLinecap="round" />
      <path
        d="M45.5967 115.811C45.5967 115.811 49.1909 108.614 50.1779 108.768C50.6478 108.844 50.8638 109.3 50.961 109.754C51.0822 110.344 51.0138 110.956 50.7652 111.506C50.2549 112.662 48.8831 114.848 45.5967 115.811Z"
        fill="#B3995B"
      />
      <path
        d="M50.1523 110.137C50.1523 110.137 46.3718 115.521 45.6494 115.758"
        stroke="#7F6D41"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path d="M50.4995 110.978H49.6191" stroke="#7F6D41" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M49.4447 112.947L48.0635 113.006" stroke="#7F6D41" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M48.6035 111.371L48.7534 112.08" stroke="#7F6D41" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M47.136 113.525L47.163 114.169" stroke="#7F6D41" strokeWidth="0.5" strokeLinecap="round" />
      <path
        d="M39.4235 117.492C39.3257 117.413 39.2545 117.307 39.2196 117.188C39.1852 117.064 39.2454 116.934 39.3627 116.878C39.4977 116.829 39.6328 116.918 39.7408 117.011C39.8488 117.104 39.9717 117.202 40.1067 117.18C39.9609 117.05 39.8953 116.854 39.9339 116.664C39.9394 116.625 39.9558 116.589 39.9811 116.559C40.054 116.482 40.1863 116.515 40.2741 116.576C40.5441 116.768 40.6292 117.138 40.6306 117.473C40.6441 117.35 40.6441 117.227 40.6306 117.104C40.6233 116.978 40.68 116.857 40.7818 116.781C40.8475 116.746 40.9216 116.728 40.9965 116.73C41.1219 116.713 41.2491 116.749 41.3462 116.829C41.4407 116.955 41.4352 117.129 41.3327 117.25C41.2292 117.364 41.1069 117.46 40.9708 117.534C40.8675 117.595 40.7794 117.679 40.7129 117.777C40.7048 117.791 40.6984 117.805 40.694 117.82H39.9082C39.7323 117.733 39.5692 117.622 39.4235 117.492Z"
        fill="#B3995B"
      />
      <path
        d="M53.1209 114.592C53.0229 114.514 52.9516 114.409 52.917 114.289C52.8824 114.166 52.942 114.036 53.0588 113.98C53.1938 113.931 53.3288 114.02 53.4368 114.113C53.5449 114.206 53.6664 114.307 53.8055 114.287C53.6597 114.157 53.5935 113.962 53.6313 113.773C53.6373 113.734 53.6541 113.697 53.6799 113.668C53.7528 113.59 53.8851 113.624 53.9729 113.683C54.2497 113.876 54.328 114.247 54.3293 114.582C54.3428 114.459 54.3428 114.334 54.3293 114.211C54.3171 114.087 54.3676 113.965 54.4643 113.884C54.5304 113.85 54.6043 113.833 54.679 113.835C54.8043 113.818 54.9311 113.853 55.0287 113.932C55.1236 114.059 55.1175 114.234 55.0139 114.355C54.9112 114.469 54.7893 114.565 54.6534 114.639C54.5501 114.699 54.4619 114.782 54.3955 114.881C54.3876 114.895 54.3812 114.909 54.3766 114.925H53.6083C53.4311 114.836 53.2671 114.725 53.1209 114.592V114.592Z"
        fill="#B3995B"
      />
      <path
        d="M48.5567 117.492C48.4589 117.413 48.3874 117.307 48.3514 117.187C48.317 117.064 48.3772 116.934 48.4946 116.878C48.6296 116.829 48.7646 116.918 48.8726 117.011C48.9806 117.104 49.1008 117.205 49.2412 117.186C49.0957 117.056 49.0296 116.861 49.067 116.671C49.073 116.632 49.0899 116.595 49.1156 116.566C49.1886 116.489 49.3209 116.522 49.4086 116.583C49.6854 116.774 49.7624 117.145 49.7651 117.48C49.7786 117.357 49.7786 117.233 49.7651 117.11C49.7545 116.985 49.8076 116.863 49.9069 116.784C49.9725 116.748 50.0467 116.731 50.1215 116.733C50.247 116.716 50.3741 116.751 50.4712 116.831C50.5659 116.958 50.5598 117.132 50.4564 117.253C50.3534 117.367 50.2315 117.463 50.0959 117.537C49.9926 117.598 49.9045 117.681 49.838 117.78C49.8298 117.793 49.8235 117.808 49.8191 117.823H49.036C48.862 117.734 48.7008 117.623 48.5567 117.492V117.492Z"
        fill="#B3995B"
      />
      <ellipse opacity="0.1" cx="38.1461" cy="38.6681" rx="2.92048" ry="2.87412" fill="#B3995B" />
      <ellipse opacity="0.1" cx="178.579" cy="61.6358" rx="2.92048" ry="2.87412" fill="#B3995B" />
      <ellipse opacity="0.1" cx="126.081" cy="29.5408" rx="2.92048" ry="2.87412" fill="#B3995B" />
      <ellipse opacity="0.1" cx="43.9872" cy="54.5242" rx="4.89447" ry="4.81678" fill="#B3995B" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.0459 93.2936C89.4442 93.2936 86.5244 96.167 86.5244 99.7116C86.5244 103.256 89.4442 106.13 93.0459 106.13C96.6476 106.13 99.5673 103.256 99.5673 99.7116C99.5673 96.167 96.6476 93.2936 93.0459 93.2936V93.2936Z"
        fill="#A38B53"
      />
      <path
        opacity="0.72"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.0451 94.0402C96.2278 94.0402 98.8079 96.5794 98.8079 99.7116C98.8079 102.844 96.2278 105.383 93.0451 105.383C89.8623 105.383 87.2822 102.844 87.2822 99.7116C87.285 96.5805 89.8635 94.0429 93.0451 94.0402"
        fill="#B3995B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.3489 100.18L90.0336 99.8776C89.9654 99.8163 89.9268 99.7306 89.9268 99.6409C89.9268 99.5513 89.9654 99.4656 90.0336 99.4043L92.8004 96.7447C92.8643 96.6792 92.9535 96.6421 93.0468 96.6421C93.1402 96.6421 93.2294 96.6792 93.2932 96.7447L96.0601 99.402C96.1269 99.4639 96.1647 99.5493 96.1647 99.6386C96.1647 99.7278 96.1269 99.8132 96.0601 99.8752L95.7447 100.178C95.6802 100.242 95.5912 100.279 95.4983 100.279C95.4054 100.279 95.3165 100.242 95.2519 100.178L93.616 98.5217V102.452C93.6166 102.539 93.5811 102.623 93.5173 102.684C93.4534 102.746 93.3666 102.781 93.276 102.781H92.8202C92.631 102.781 92.4777 102.634 92.4777 102.452V98.5264L90.8417 100.183C90.7768 100.247 90.6877 100.283 90.5948 100.282C90.5019 100.282 90.4132 100.245 90.3489 100.18V100.18Z"
        fill="#A38B53"
      />
      <defs>
        <linearGradient
          id="paint0_linear_610_34916"
          x1="148.495"
          y1="188.459"
          x2="226.132"
          y2="10.6558"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#B3995B" />
          <stop offset="1" stopColor="#B3995B" stopOpacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_610_34916"
          x1="80.6711"
          y1="60.9952"
          x2="59.4163"
          y2="124.769"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#B3995B" />
          <stop offset="1" stopColor="#7F6D41" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const NoIngredientFoundIcon = (): JSX.Element => {
  return (
    <svg width="129" height="128" viewBox="0 0 129 128" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="5.5"
        y="31"
        width="31.75"
        height="21.8966"
        rx="4"
        stroke="#B3995B"
        strokeWidth="3.00068"
        strokeLinecap="round"
      />
      <path d="M10.5 43H27.5M10.5 48H19.5152" stroke="#B3995B" strokeWidth="3.00068" strokeLinecap="round" />
      <rect
        x="10.3794"
        y="34.7842"
        width="5.02155"
        height="5.02155"
        rx="1.5"
        fill="#B3995B"
        stroke="#B3995B"
      />
      <rect
        x="13.5"
        y="86"
        width="31.75"
        height="21.8966"
        rx="4"
        stroke="#B3995B"
        strokeWidth="3.00068"
        strokeLinecap="round"
      />
      <path d="M18.5 98H35.5M18.5 103H27.5152" stroke="#B3995B" strokeWidth="3.00068" strokeLinecap="round" />
      <rect
        x="18.3794"
        y="89.7842"
        width="5.02155"
        height="5.02155"
        rx="1.5"
        fill="#B3995B"
        stroke="#B3995B"
      />
      <rect
        x="90.5"
        y="42"
        width="31.75"
        height="21.8966"
        rx="4"
        stroke="#B3995B"
        strokeWidth="3.00068"
        strokeLinecap="round"
      />
      <path d="M95.5 54H112.5M95.5 59H104.515" stroke="#B3995B" strokeWidth="3.00068" strokeLinecap="round" />
      <rect
        x="95.3794"
        y="45.7842"
        width="5.02155"
        height="5.02155"
        rx="1.5"
        fill="#B3995B"
        stroke="#B3995B"
      />
      <rect
        x="47.5"
        y="54"
        width="31.75"
        height="21.8966"
        rx="4"
        stroke="#D0D4E6"
        strokeWidth="3.00068"
        strokeLinecap="round"
      />
      <path
        d="M52.4268 66.043H69.3966M52.4268 69.8749H61.4259"
        stroke="#D0D4E6"
        strokeWidth="3.00068"
        strokeLinecap="round"
      />
      <rect x="51.8794" y="57.2842" width="6.02155" height="6.02155" rx="2" fill="#D0D4E6" />
      <path
        d="M91.2425 36.7425C86.1433 31.6433 79.9994 28.2256 73.4998 26.4892C62.9554 23.6724 51.4749 25.2809 41.9998 31.3147M24.0607 58.9998C23.1092 65.5273 23.7893 72.2468 26.1009 78.4998M54.9998 103.478C64.9816 105.592 75.622 103.82 84.4998 98.161M96.9745 85.4998C100.023 80.555 101.883 75.0853 102.555 69.4998"
        stroke="#D9E5FF"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.8356 43.4073C73.0464 31.6181 53.9324 31.6181 42.1432 43.4073C30.354 55.1965 30.354 74.3106 42.1432 86.0998C53.0694 97.026 70.2874 97.8258 82.1347 88.4992L98.7622 105.127C100.194 106.558 102.514 106.558 103.946 105.127C105.377 103.695 105.377 101.375 103.946 99.9433L87.3081 83.3058C96.5574 71.4615 95.7333 54.305 84.8356 43.4073ZM47.0929 48.3571C56.1485 39.3015 70.8304 39.3015 79.8859 48.3571C88.9414 57.4126 88.9414 72.0945 79.8859 81.1501C70.8304 90.2056 56.1485 90.2056 47.0929 81.1501C38.0374 72.0945 38.0374 57.4126 47.0929 48.3571Z"
        fill="#B3995B"
      />
    </svg>
  );
};
export const SearchInputIcon = () => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.31 12.9L17.71 16.29C17.8993 16.4778 18.0058 16.7334 18.0058 17C18.0058 17.2666 17.8993 17.5222 17.71 17.71C17.5222 17.8993 17.2666 18.0058 17 18.0058C16.7334 18.0058 16.4778 17.8993 16.29 17.71L12.9 14.31C11.5025 15.407 9.77666 16.0022 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16.0022 9.77666 15.407 11.5025 14.31 12.9ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z"
        fill="#919EAB"
      />
    </svg>
  );
};

export const ActiveDotIcon: JSX.Element = (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4" r="4" transform="matrix(1 0 0 -1 0 8)" fill="#B3995B" />
  </svg>
);

export const DashboardIcon: JSX.Element = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.75 9.91667H8.08333V0.75H0.75V9.91667ZM0.75 17.25H8.08333V11.75H0.75V17.25ZM9.91667 17.25H17.25V8.08333H9.91667V17.25ZM9.91667 0.75V6.25H17.25V0.75H9.91667Z"
      fill="#B3995B"
    />
  </svg>
);

export const UsersIcon: JSX.Element = (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2808 12.0358C16.5367 12.8883 17.4167 14.0433 17.4167 15.5833V18.3333H21.0833V15.5833C21.0833 13.585 17.8108 12.4025 15.2808 12.0358Z"
      fill="#919EAB"
    />
    <path
      d="M8.24998 11C10.275 11 11.9166 9.35837 11.9166 7.33332C11.9166 5.30828 10.275 3.66666 8.24998 3.66666C6.22494 3.66666 4.58331 5.30828 4.58331 7.33332C4.58331 9.35837 6.22494 11 8.24998 11Z"
      fill="#919EAB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 11C15.7759 11 17.4167 9.35916 17.4167 7.33332C17.4167 5.30749 15.7759 3.66666 13.75 3.66666C13.3192 3.66666 12.9159 3.75832 12.5309 3.88666C13.3197 4.86219 13.75 6.07878 13.75 7.33332C13.75 8.58787 13.3197 9.80446 12.5309 10.78C12.9159 10.9083 13.3192 11 13.75 11ZM8.25002 11.9167C5.80252 11.9167 0.916687 13.145 0.916687 15.5833V18.3333H15.5834V15.5833C15.5834 13.145 10.6975 11.9167 8.25002 11.9167Z"
      fill="#919EAB"
    />
  </svg>
);

export const ProductsIcon: JSX.Element = (
  <svg width="22" height="22" viewBox="0 0 512 512">
    <path
      d="M471.199,231.069L271.6,33.725l0.044,0.093C249.149,11.271,219.501-0.05,189.995,0
		c-29.463-0.05-59.112,11.271-81.609,33.818c-22.54,22.49-33.857,52.092-33.815,81.609c-0.042,29.502,11.274,59.147,33.815,81.645
		l47.106,46.6c-1.42-0.043-2.842-0.043-4.259-0.043c-38.632,0-73.726,9.714-99.984,26.161
		c-13.106,8.245-24.057,18.189-31.846,29.782c-7.832,11.55-12.417,24.835-12.417,38.858v78.719c0,14.016,4.585,27.308,12.417,38.858
		c11.732,17.364,30.377,31.15,53.107,40.83c22.773,9.664,49.762,15.113,78.723,15.163c38.579-0.05,73.676-9.758,99.93-26.211
		c13.149-8.202,24.054-18.188,31.89-29.781c7.793-11.55,12.374-24.842,12.374-38.858v-35.144l12.554,12.425l-0.043-0.1
		c22.494,22.54,52.143,33.868,81.648,33.818c29.466,0.05,59.112-11.278,81.612-33.768c22.54-22.548,33.814-52.143,33.814-81.659
		C505.013,283.212,493.739,253.609,471.199,231.069z M141.473,148.686c-19.106-19.149-19.106-50.63,0.272-70.009
		c9.346-9.349,21.809-14.525,35.102-14.525L141.473,148.686z M29.896,338.43c0.043-9.026,2.839-17.637,8.482-26.075
		c4.95-7.37,12.231-14.432,21.347-20.705l175.312,102.594c-3.986,2.194-8.201,4.259-12.65,6.137
		c-20.113,8.567-44.672,13.608-71.152,13.608c-35.38,0.05-67.27-9.026-89.764-23.186c-11.27-7.097-20.16-15.4-26.118-24.283
		c-2.205-3.305-4.033-6.645-5.456-10.08V338.43z M272.518,417.15c0,9.026-2.842,17.644-8.474,26.068
		c-8.438,12.56-23.418,24.196-43.074,32.542c-19.612,8.338-43.715,13.335-69.736,13.335c-34.735,0-66.029-8.94-87.792-22.684
		c-10.908-6.832-19.433-14.848-25.064-23.193c-5.642-8.424-8.439-17.042-8.482-26.068v-32.484
		c11.087,12.274,26.211,22.498,44.034,30.054c22.268,9.449,48.798,14.854,77.304,14.854c37.983,0,72.44-9.586,98.005-25.623
		c8.98-5.586,16.816-12.045,23.279-19.243V417.15z M272.518,356.44c-0.272,0.688-0.552,1.326-0.918,2.014
		c-1.233,2.753-2.749,5.406-4.538,8.065c-3.847,5.772-9.026,11.228-15.164,16.311L78.329,281.29c1.054-0.459,2.065-1.011,3.116-1.42
		c19.611-8.338,43.715-13.335,69.79-13.335c10.26,0,20.208,0.781,29.689,2.251c22.637,3.434,42.704,10.762,58.054,20.382
		c1.878,1.147,3.667,2.388,5.359,3.628c8.294,5.908,14.847,12.46,19.475,19.293c0.093,0.086,0.183,0.179,0.233,0.265
		c5.632,8.438,8.474,17.049,8.474,26.075V356.44z M451.77,374.9c-17.228,17.192-39.639,25.752-62.183,25.752
		c-22.588,0-44.991-8.524-62.223-25.752l-0.046-0.043l-31.89-31.524v-4.903c0-14.024-4.581-27.309-12.374-38.858
		c-9.801-14.432-24.326-26.39-42.016-35.553c2.201-5.728,4.994-11.966,8.432-18.368c9.714-18.246,24.286-38.041,43.578-53.247
		c19.196-15.17,42.798-25.982,71.984-27.638l86.692,85.731h0.046c17.182,17.228,25.749,39.683,25.749,62.223
		C477.519,335.268,468.952,357.723,451.77,374.9z"
    />
  </svg>
);

export const IngredientsIcon: JSX.Element = (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.54585 7.37917C4.34574 8.57949 3.67001 10.2064 3.66658 11.9037C3.66314 13.6011 4.33227 15.2307 5.52752 16.4358C6.87502 13.3192 9.27669 10.7158 12.2742 9.16667C9.68696 11.3558 7.94048 14.3757 7.33335 17.71C9.71669 18.8375 12.65 18.425 14.6209 16.4542C17.8109 13.2642 18.3334 3.66667 18.3334 3.66667C18.3334 3.66667 8.73585 4.18917 5.54585 7.37917Z"
      fill="#919EAB"
    />
  </svg>
);

export const RequestSentSuccessIcon = () => {
  return (
    <svg width="104" height="120" viewBox="0 0 104 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.48062"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.4753 119.471C55.13 119.564 54.7747 119.359 54.6817 119.014C54.5887 118.669 54.7932 118.313 55.1384 118.22C55.6424 118.085 56.1676 117.943 56.8054 117.772C57.1508 117.679 57.506 117.884 57.5988 118.229C57.6915 118.575 57.4868 118.93 57.1414 119.023C56.5039 119.194 55.979 119.335 55.4753 119.471ZM62.1455 117.676C61.8004 117.769 61.4448 117.565 61.3514 117.22C61.258 116.875 61.4622 116.519 61.8073 116.426C62.3886 116.269 62.9394 116.119 63.4722 115.974C63.8172 115.88 64.1732 116.083 64.2672 116.428C64.3612 116.773 64.1578 117.129 63.8128 117.223C63.2792 117.369 62.7275 117.519 62.1455 117.676ZM68.8107 115.838C68.4666 115.935 68.1087 115.735 68.0114 115.391C67.9141 115.047 68.1141 114.689 68.4582 114.592C69.0214 114.433 69.573 114.275 70.1153 114.119C70.459 114.02 70.8177 114.219 70.9166 114.562C71.0155 114.906 70.8171 115.265 70.4734 115.364C69.9292 115.52 69.3757 115.678 68.8107 115.838ZM75.4512 113.887C75.1093 113.992 74.7472 113.8 74.6424 113.458C74.5376 113.116 74.7297 112.754 75.0716 112.649C75.6268 112.479 76.1746 112.309 76.7159 112.139C77.0571 112.031 77.4206 112.221 77.5278 112.562C77.6351 112.903 77.4455 113.267 77.1043 113.374C76.5601 113.545 76.0093 113.716 75.4512 113.887ZM82.0467 111.754C81.7083 111.87 81.3402 111.69 81.2244 111.351C81.1085 111.013 81.2889 110.645 81.6272 110.529C82.1744 110.342 82.7158 110.153 83.252 109.964C83.5892 109.845 83.9591 110.022 84.0782 110.359C84.1973 110.696 84.0205 111.066 83.6833 111.185C83.1431 111.376 82.5977 111.565 82.0467 111.754ZM88.5594 109.374C88.2263 109.504 87.8508 109.34 87.7207 109.007C87.5905 108.674 87.755 108.298 88.088 108.168C88.5468 107.989 89.002 107.808 89.451 107.627C89.5671 107.58 89.5671 107.58 89.6819 107.533C90.0125 107.396 90.391 107.554 90.5272 107.885C90.6634 108.215 90.5057 108.594 90.1751 108.73C90.0584 108.778 90.0584 108.778 89.9378 108.827C89.4817 109.011 89.0223 109.193 88.5594 109.374ZM94.93 106.488C94.6177 106.662 94.2233 106.55 94.0491 106.238C93.8749 105.926 93.9869 105.532 94.2992 105.357C94.8038 105.076 95.2844 104.788 95.7435 104.491C96.0438 104.297 96.4447 104.383 96.6388 104.683C96.833 104.983 96.747 105.384 96.4467 105.578C95.9633 105.891 95.4586 106.193 94.93 106.488ZM100.531 102.049C100.315 102.334 99.9087 102.389 99.624 102.173C99.3393 101.956 99.284 101.55 99.5004 101.265C99.8319 100.829 100.105 100.374 100.306 99.9142C100.449 99.5865 100.831 99.437 101.158 99.5802C101.486 99.7235 101.635 100.105 101.492 100.433C101.249 100.99 100.923 101.534 100.531 102.049ZM100.866 94.8346C101.061 95.1344 100.976 95.5354 100.676 95.7304C100.376 95.9254 99.9753 95.8405 99.7802 95.5408C99.4988 95.1082 99.1635 94.6941 98.7751 94.2953C98.5256 94.0391 98.5311 93.6291 98.7873 93.3797C99.0435 93.1302 99.4534 93.1356 99.7029 93.3918C100.148 93.8493 100.537 94.3289 100.866 94.8346ZM95.2723 90.2783C95.5887 90.4447 95.7104 90.8362 95.5439 91.1527C95.3774 91.4692 94.9859 91.5908 94.6694 91.4244C94.5771 91.3758 94.4833 91.327 94.4008 91.2843C93.989 91.0841 93.5735 90.8955 93.1496 90.7161C92.8202 90.5768 92.6661 90.1969 92.8055 89.8676C92.9448 89.5382 93.3247 89.3842 93.654 89.5235C94.0987 89.7116 94.5349 89.9095 94.9804 90.1264C95.0793 90.1773 95.1765 90.2279 95.2723 90.2783ZM88.6171 87.8921C88.9649 87.975 89.1797 88.3242 89.0967 88.6721C89.0138 89.0199 88.6646 89.2347 88.3167 89.1517C87.7751 89.0226 87.222 88.904 86.6562 88.7953C86.3051 88.7278 86.0751 88.3884 86.1426 88.0372C86.2101 87.6861 86.5495 87.4561 86.9006 87.5236C87.4848 87.6359 88.0565 87.7584 88.6171 87.8921ZM81.7018 86.8099C82.0579 86.8425 82.3201 87.1576 82.2875 87.5137C82.255 87.8698 81.9399 88.1321 81.5837 88.0995C81.0318 88.049 80.4647 88.0037 79.8768 87.9629C79.5201 87.9381 79.251 87.6288 79.2757 87.2721C79.3005 86.9154 79.6098 86.6463 79.9665 86.671C80.5636 86.7125 81.1401 86.7585 81.7018 86.8099ZM74.7453 86.4197C75.1027 86.4321 75.3824 86.7319 75.37 87.0893C75.3576 87.4466 75.0579 87.7263 74.7005 87.7139C74.4433 87.705 74.1791 87.6961 73.8474 87.6849C73.5736 87.6807 73.2976 87.6773 73.0189 87.6745C72.6613 87.671 72.3743 87.3782 72.3778 87.0206C72.3814 86.6631 72.6741 86.3761 73.0317 86.3796C73.3127 86.3824 73.591 86.3859 73.8789 86.3904C74.2228 86.4019 74.4875 86.4108 74.7453 86.4197ZM67.836 86.3981C68.1935 86.3929 68.4876 86.6785 68.4928 87.036C68.4981 87.3936 68.2124 87.6877 67.8549 87.6929C67.3024 87.701 66.7319 87.7108 66.1317 87.7225C65.7742 87.7295 65.4787 87.4453 65.4717 87.0878C65.4647 86.7303 65.7489 86.4348 66.1064 86.4278C66.7087 86.4161 67.2813 86.4062 67.836 86.3981ZM60.9241 86.5484C61.2816 86.5396 61.5785 86.8223 61.5873 87.1797C61.596 87.5372 61.3134 87.8342 60.9559 87.8429C60.2796 87.8595 59.7453 87.8724 59.2288 87.8842C58.8713 87.8925 58.5748 87.6093 58.5666 87.2518C58.5584 86.8943 58.8415 86.5978 59.199 86.5896C59.7148 86.5778 60.2484 86.565 60.9241 86.5484ZM54.0298 86.6775C54.3874 86.6745 54.6797 86.9619 54.6828 87.3194C54.6858 87.677 54.3985 87.9694 54.0409 87.9725C53.679 87.9756 53.3235 87.9778 52.9755 87.9791C52.7587 87.9807 52.5399 87.9831 52.3174 87.9862C51.9598 87.9911 51.666 87.7052 51.6611 87.3477C51.6561 86.9901 51.942 86.6962 52.2995 86.6913C52.5247 86.6882 52.7462 86.6858 52.9681 86.6842C53.3165 86.6828 53.67 86.6806 54.0298 86.6775ZM47.1137 86.8252C47.4712 86.8164 47.7682 87.099 47.777 87.4565C47.7859 87.814 47.5032 88.111 47.1457 88.1198C46.5116 88.1355 45.9494 88.1457 45.4092 88.1506C45.0517 88.1539 44.7591 87.8667 44.7559 87.5091C44.7526 87.1515 45.0398 86.859 45.3974 86.8557C45.9302 86.8508 46.4859 86.8407 47.1137 86.8252ZM40.2756 86.6867C40.632 86.7166 40.8966 87.0297 40.8667 87.3861C40.8369 87.7424 40.5238 88.0071 40.1674 87.9772C39.5882 87.9286 39.0089 87.8692 38.4255 87.7982C38.0705 87.7549 37.8178 87.4321 37.861 87.0772C37.9042 86.7222 38.227 86.4695 38.582 86.5127C39.1493 86.5818 39.7124 86.6395 40.2756 86.6867ZM33.5514 85.6254C33.9 85.7049 34.1182 86.052 34.0387 86.4006C33.9593 86.7493 33.6122 86.9675 33.2635 86.888C32.7356 86.7676 32.1992 86.6375 31.6533 86.4974C31.6065 86.4853 31.6065 86.4853 31.5619 86.4735C31.2162 86.3819 31.0103 86.0275 31.1018 85.6818C31.1934 85.3361 31.5479 85.1302 31.8935 85.2217C31.9333 85.2322 31.9333 85.2322 31.9754 85.2431C32.51 85.3804 33.035 85.5077 33.5514 85.6254ZM27.5192 82.9846C27.7979 83.2086 27.8422 83.6162 27.6181 83.8949C27.3941 84.1736 26.9865 84.2179 26.7078 83.9938C26.2356 83.6142 25.7893 83.2037 25.3735 82.7666C25.1271 82.5075 25.1373 82.0977 25.3964 81.8512C25.6555 81.6048 26.0653 81.615 26.3118 81.8741C26.6878 82.2695 27.0918 82.6409 27.5192 82.9846ZM23.7556 77.6522C23.8655 77.9925 23.6787 78.3575 23.3384 78.4674C22.9981 78.5772 22.6332 78.3905 22.5233 78.0502C22.3335 77.4622 22.1942 76.8645 22.1077 76.2614C22.057 75.9075 22.3028 75.5794 22.6567 75.5286C23.0107 75.4778 23.3388 75.7236 23.3896 76.0776C23.4655 76.6073 23.5881 77.1335 23.7556 77.6522ZM23.9253 71.319C23.8061 71.6561 23.4361 71.8328 23.099 71.7135C22.7618 71.5943 22.5852 71.2244 22.7044 70.8872C22.903 70.3257 23.1422 69.7716 23.4208 69.224C23.5829 68.9052 23.9727 68.7783 24.2915 68.9404C24.6102 69.1026 24.7371 69.4924 24.575 69.8111C24.3216 70.3093 24.1047 70.8116 23.9253 71.319ZM27.5079 65.7409C27.2644 66.0027 26.8547 66.0176 26.5928 65.774C26.331 65.5305 26.3161 65.1208 26.5596 64.859C26.9493 64.44 27.3623 64.0227 27.8002 63.6039C28.0587 63.3568 28.4686 63.366 28.7157 63.6245C28.9628 63.8829 28.9536 64.2928 28.6952 64.5399C28.275 64.9417 27.8798 65.341 27.5079 65.7409Z"
        fill="#B3995B"
      />
      <path
        d="M102.676 0.247122C103.332 0.411854 103.486 1.2061 103.318 1.77678C102.941 3.45352 102.288 5.05377 101.773 6.69227C94.6062 29.0635 87.4398 51.4347 80.2733 73.8059C80.1144 74.6884 79.1873 75.3444 78.3132 75.1532C69.1984 67.702 60.0601 60.2714 50.9276 52.8408C46.7897 57.1739 42.7135 61.5834 38.2223 65.5546C37.0745 66.496 35.9326 67.4902 34.5699 68.1021C34.205 68.2139 33.5516 68.4286 33.3838 67.9344C33.3338 67.0402 33.5604 66.1606 33.6517 65.2781C34.7494 56.7179 35.8619 48.1577 37.0303 39.6064C25.2726 37.8678 13.5179 36.1323 1.76022 34.4055C1.13334 34.2996 0.300438 34.1849 0.0738197 33.4818C-0.0497905 32.5935 0.821367 32.0522 1.55126 31.8228C6.35734 30.449 11.0898 28.837 15.8636 27.3544C44.029 18.4088 72.1974 9.46918 100.363 0.523636C101.108 0.308896 101.896 0.0529729 102.676 0.247122Z"
        fill="url(#paint0_linear_610_33833)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.0729 28.9807C59.4605 26.9755 62.848 24.9704 66.2432 22.9801C76.3086 17.0439 86.374 11.1047 96.4394 5.16553C91.8697 8.84141 87.2455 12.4526 82.6211 16.064C79.7997 18.2673 76.9782 20.4707 74.1689 22.6889C71.0574 25.1285 67.9462 27.5684 64.835 30.0083C58.6087 34.8911 52.3825 39.774 46.1536 44.6542C45.8812 44.8725 45.5978 45.0785 45.3143 45.2845C44.746 45.6976 44.1771 46.1109 43.6961 46.6251C43.1129 47.2642 42.8209 48.0755 42.5313 48.8799C42.4424 49.1269 42.3537 49.3733 42.2569 49.6138C41.5542 51.4077 40.8013 53.1829 40.0481 54.9586C39.6058 56.0015 39.1634 57.0445 38.7311 58.0916C37.6068 60.795 36.4149 63.4866 34.8491 65.9723C35.4798 60.7589 36.1716 55.5542 36.8634 50.3497C37.3079 47.0056 37.7524 43.6616 38.1807 40.3153C38.1954 40.2353 38.2055 40.151 38.2158 40.0654C38.2569 39.7229 38.3001 39.3622 38.6487 39.1974C44.4826 35.841 50.2778 32.4108 56.0729 28.9807ZM36.2383 66.0429C39.3256 60.0655 41.995 53.8821 44.5672 47.6694C45.0166 48.0369 45.465 48.4056 45.9134 48.7744C47.2921 49.9081 48.671 51.042 50.0767 52.1407C45.7827 57.065 41.1974 61.7775 36.2383 66.0429Z"
        fill="#7F6D41"
      />
      <defs>
        <linearGradient
          id="paint0_linear_610_33833"
          x1="12.4263"
          y1="20.3023"
          x2="13.8241"
          y2="76.8821"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#B3995B" />
          <stop offset="1" stopColor="#826625" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PasswordSuccessIcon = () => {
  return (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M60 11.25C50.3582 11.25 40.9329 14.1091 32.916 19.4659C24.8991 24.8226 18.6507 32.4363 14.9609 41.3442C11.2711 50.2521 10.3057 60.0541 12.1867 69.5107C14.0678 78.9672 18.7108 87.6536 25.5286 94.4715C32.3464 101.289 41.0328 105.932 50.4894 107.813C59.9459 109.694 69.7479 108.729 78.6558 105.039C87.5637 101.349 95.1774 95.1009 100.534 87.084C105.891 79.0671 108.75 69.6418 108.75 60C108.725 47.0783 103.581 34.6929 94.4441 25.5559C85.3071 16.4189 72.9217 11.2748 60 11.25V11.25ZM83.2031 51.4688L55.7344 77.7188C55.0243 78.3868 54.0843 78.756 53.1094 78.75C52.6329 78.7568 52.1597 78.6692 51.7172 78.4922C51.2747 78.3152 50.8716 78.0523 50.5313 77.7188L36.7969 64.5938C36.416 64.2614 36.1061 63.8554 35.8861 63.4003C35.666 62.9452 35.5403 62.4502 35.5164 61.9452C35.4925 61.4403 35.571 60.9357 35.7471 60.4618C35.9232 59.9879 36.1933 59.5545 36.5411 59.1877C36.889 58.8208 37.3074 58.5281 37.7713 58.3271C38.2352 58.1261 38.7349 58.021 39.2404 58.0181C39.746 58.0152 40.2469 58.1145 40.7131 58.3101C41.1792 58.5056 41.601 58.7935 41.9531 59.1562L53.1094 69.7969L78.0469 46.0312C78.776 45.3951 79.7229 45.0654 80.6894 45.1112C81.656 45.1569 82.5675 45.5745 83.2333 46.2766C83.8991 46.9788 84.2678 47.9111 84.2621 48.8788C84.2565 49.8464 83.8771 50.7744 83.2031 51.4688Z"
        fill="url(#paint0_linear_610_33834)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_610_33834"
          x1="22.918"
          y1="37.4084"
          x2="25.4193"
          y2="110.914"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#B3995B" />
          <stop offset="1" stopColor="#826625" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CustomerIcon: JSX.Element = (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.4156 13.5694C11.338 12.9566 12.0386 12.0632 12.4138 11.0213C12.789 9.97939 12.8187 8.8444 12.4987 7.78427C12.1787 6.72414 11.5259 5.7952 10.6368 5.13494C9.74782 4.47468 8.66986 4.11816 7.56248 4.11816C6.4551 4.11816 5.37714 4.47468 4.48812 5.13494C3.59911 5.7952 2.94628 6.72414 2.62625 7.78427C2.30622 8.8444 2.33599 9.97939 2.71115 11.0213C3.08632 12.0632 3.78695 12.9566 4.70935 13.5694C3.13581 14.148 1.77723 15.1947 0.816385 16.5686C0.741333 16.6705 0.696661 16.7915 0.687536 16.9178C0.678411 17.044 0.705206 17.1702 0.764822 17.2819C0.823734 17.3928 0.911551 17.4857 1.01897 17.5507C1.12639 17.6158 1.2494 17.6506 1.37498 17.6514H13.75C13.8756 17.6506 13.9986 17.6158 14.106 17.5507C14.2134 17.4857 14.3012 17.3928 14.3601 17.2819C14.4198 17.1702 14.4465 17.044 14.4374 16.9178C14.4283 16.7915 14.3836 16.6705 14.3086 16.5686C13.3477 15.1947 11.9891 14.148 10.4156 13.5694Z"
      fill="currentColor"
    />
    <path
      d="M21.3211 16.5688C20.3548 15.1966 18.9941 14.1506 17.4196 13.5696C18.3449 12.9591 19.0484 12.0663 19.4256 11.0239C19.8027 9.9815 19.8332 8.8452 19.5127 7.78403C19.1921 6.72286 18.5375 5.79353 17.6463 5.13427C16.7552 4.47501 15.675 4.12104 14.5664 4.12503C14.0933 4.12754 13.6225 4.19109 13.1657 4.3141C13.0583 4.34633 12.9603 4.40368 12.8796 4.4814C12.7989 4.55911 12.7378 4.65496 12.7016 4.76097C12.667 4.86612 12.6583 4.97806 12.6763 5.08728C12.6942 5.1965 12.7383 5.29977 12.8047 5.38831C13.5819 6.4326 14.0285 7.68581 14.0867 8.98629C14.1449 10.2868 13.8121 11.5749 13.1313 12.6844C13.044 12.8318 13.0141 13.0063 13.0474 13.1744C13.0807 13.3424 13.1748 13.4923 13.3117 13.5953C13.5696 13.7959 13.8188 14.0021 14.0594 14.2141L14.1024 14.2571C15.0197 15.1059 15.7638 16.1244 16.2938 17.2563C16.3482 17.3746 16.4354 17.4747 16.5451 17.5448C16.6548 17.6149 16.7823 17.652 16.9125 17.6516H20.7539C20.8795 17.6508 21.0025 17.616 21.1099 17.5509C21.2174 17.4859 21.3052 17.393 21.3641 17.2821C21.423 17.1707 21.4501 17.0452 21.4426 16.9194C21.435 16.7936 21.393 16.6723 21.3211 16.5688Z"
      fill="currentColor"
    />
  </svg>
);

export const FormulaIcon: JSX.Element = (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.58332 13.2914H17.4166V7.79141H4.58332V13.2914ZM10.0833 0.503906V3.20807H11.9166V0.503906H10.0833ZM17.4533 2.79557L15.8125 4.43641L17.105 5.72891L18.755 4.08807L17.4533 2.79557ZM11.9166 20.5789V17.8747H10.0833V20.5789H11.9166ZM18.7458 16.9947L17.0958 15.3539L15.8033 16.6464L17.4441 18.2964L18.7458 16.9947ZM3.25415 4.08807L4.89498 5.72891L6.18748 4.43641L4.54665 2.79557L3.25415 4.08807ZM4.54665 18.2872L6.18748 16.6372L4.89498 15.3447L3.25415 16.9856L4.54665 18.2872Z"
      fill="#919EAB"
    />
  </svg>
);

export const ArrowIcon = (): JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99992 3.33301L8.82492 4.50801L13.4749 9.16634H3.33325V10.833H13.4749L8.82492 15.4913L9.99992 16.6663L16.6666 9.99967L9.99992 3.33301Z"
      fill="white"
    />
  </svg>
);

export const CloseIcon = (): JSX.Element => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.4168 5.87551L16.1243 4.58301L11.0002 9.70717L5.876 4.58301L4.5835 5.87551L9.70766 10.9997L4.5835 16.1238L5.876 17.4163L11.0002 12.2922L16.1243 17.4163L17.4168 16.1238L12.2927 10.9997L17.4168 5.87551Z"
      fill="#B72136"
    />
  </svg>
);

export const LogoIcon: FC<IconProps> = ({ width = 184, height = 68 }) => (
  <svg width={width} height={height} viewBox="0 0 973 327" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M376.962 155.948L388.39 83.8655H445.267C469.578 83.8655 477.036 93.1625 477.036 105.659C477.036 118.746 470.938 133.371 441.682 133.371H407.344L403.814 155.948H376.962ZM438.866 115.354C446.036 115.354 448.852 112.059 448.852 107.705C448.852 103.915 446.325 101.883 440.803 101.883H412.316L410.187 115.354H438.866Z"
      fill="#AD8E55"
    />
    <path
      d="M536.62 144.316H496.417L489.439 155.948H461.969L506.924 83.8655H542.869L569.323 155.948H540.479L536.62 144.316ZM522.184 101.402L507.171 126.272H530.617L522.184 101.402Z"
      fill="#AD8E55"
    />
    <path
      d="M595.241 103.531H565.203L568.307 83.8655H655.305L652.119 103.531H622.204L613.866 155.948H586.904L595.241 103.531Z"
      fill="#AD8E55"
    />
    <path
      d="M665.099 83.8655H691.937L687.817 109.339H730.931L734.915 83.8655H761.753L750.312 155.948H723.514L727.882 128.483H684.864L680.496 155.948H653.657L665.099 83.8655Z"
      fill="#AD8E55"
    />
    <path
      d="M87.4931 189.579L84.6774 207.212H35.2307L33.7748 216.22H82.26L79.5129 233.949H30.9041L26.5501 261.647H0L11.4277 189.579H87.4931Z"
      fill="#AD8E55"
    />
    <path
      d="M89.6221 230.749C89.6185 228.091 89.779 225.436 90.1029 222.798C92.0395 209.725 99.2093 188.219 144.165 188.219H148.532C189.216 188.219 197.265 206.525 197.265 219.997C197.282 222.554 197.121 225.11 196.784 227.646C194.834 241.021 187.966 263.007 142.612 263.007H138.258C97.7534 263.007 89.6221 244.372 89.6221 230.749ZM145.14 207.596C124.207 207.596 118.878 216.797 118.013 224.254C117.857 225.41 117.789 226.576 117.807 227.742C117.807 235.006 122.559 243.534 141.747 243.534C162.35 243.534 167.707 234.237 168.97 226.286C169.166 225.037 169.262 223.774 169.259 222.51C169.259 215.245 164.122 207.596 145.14 207.596Z"
      fill="#AD8E55"
    />
    <path
      d="M227.386 261.647H200.534L211.975 189.579H276.215C295.018 189.579 302.668 196.445 302.668 206.813C302.668 218.156 292.985 223.581 285.527 225.325C293.177 227.549 298.891 232.878 297.435 242.175L295.595 253.518C295.011 256.038 295.043 258.662 295.691 261.167L295.595 261.647H268.125C267.74 260.975 267.644 259.903 268.028 257.528L269.292 249.576C270.666 241.337 267.451 236.984 256.697 236.984H231.259L227.386 261.647ZM265.089 219.516C271.778 219.516 274.099 215.932 274.099 212.54C274.099 209.148 272.259 207.115 266.737 207.115H236.012L233.979 219.475L265.089 219.516Z"
      fill="#AD8E55"
    />
    <path
      d="M324.658 261.647L307.119 189.579H336.292L345.907 237.039L366.345 189.579H396.384L404.432 236.462L426.409 189.579H454.634L417.549 261.647H386.384L377.374 216.028L357.403 261.647H324.658Z"
      fill="#AD8E55"
    />
    <path
      d="M507.583 250.03H467.367L460.389 261.647H432.919L477.984 189.579H513.929L540.383 261.647H511.553L507.583 250.03ZM493.093 207.115L478.121 232.013H501.567L493.093 207.115Z"
      fill="#AD8E55"
    />
    <path
      d="M572.592 261.647H545.753L557.181 189.579H621.421C640.21 189.579 647.874 196.445 647.874 206.813C647.874 218.156 638.177 223.581 630.719 225.325C638.37 227.549 644.097 232.878 642.641 242.175L640.801 253.518C640.209 256.037 640.242 258.663 640.897 261.167L640.801 261.647H613.331C612.946 260.975 612.85 259.903 613.234 257.528L614.498 249.576C615.872 241.337 612.657 236.984 601.903 236.984H576.465L572.592 261.647ZM610.281 219.516C616.957 219.516 619.292 215.932 619.292 212.54C619.292 209.148 617.451 207.115 611.929 207.115H581.204L579.171 219.475L610.281 219.516Z"
      fill="#AD8E55"
    />
    <path
      d="M661.239 189.579H708.227C745.82 189.579 756.671 204.3 756.671 220.573C756.68 223.362 756.487 226.148 756.094 228.909C753.855 243.823 743.595 261.744 702.801 261.647H649.797L661.239 189.579ZM679.548 242.573H699.601C727.511 242.573 728.569 227.549 728.569 222.798C728.569 216.316 725.08 208.461 704.93 208.461H684.973L679.548 242.573Z"
      fill="#AD8E55"
    />
    <path
      d="M282.739 291.941V300.346H258.455V304.644H282.23V313.035H258.455V326.232H245.475V291.9L282.739 291.941Z"
      fill="#D6D6D6"
    />
    <path
      d="M313.904 291.296C336.059 291.296 338.929 301.815 338.929 308.324V309.698C338.929 316.125 336.182 326.918 313.904 326.918H311.789C289.538 326.918 286.722 316.125 286.722 309.698V308.324C286.722 301.815 289.469 291.296 311.789 291.296H313.904ZM312.832 300.524C302.49 300.524 300.32 305.001 300.32 308.654V309.203C300.32 312.815 302.682 317.649 312.832 317.649C322.983 317.649 325.345 312.952 325.345 309.299V308.654C325.345 305.001 323.038 300.524 312.832 300.524Z"
      fill="#D6D6D6"
    />
    <path
      d="M356.648 326.287H343.544V291.955H374.751C384.818 291.955 389.2 295.182 389.2 300.772V301.28C389.2 306.265 384.86 308.297 382.332 308.942C386.535 309.917 389.392 312.678 389.392 317.182V322.263C389.267 323.588 389.489 324.923 390.038 326.136V326.369H376.66C376.314 325.837 376.164 325.201 376.234 324.57V320.56C376.234 316.591 374.435 314.6 369.27 314.6H356.703L356.648 326.287ZM356.648 306.21H371.756C374.627 306.21 375.726 304.919 375.726 303.257C375.726 301.65 374.668 300.36 371.756 300.36H356.648V306.21Z"
      fill="#D6D6D6"
    />
    <path
      d="M394.282 291.941H412.289L422.81 311.236L433.523 291.941H450.802V326.273H437.823V304.85L425.79 326.287H419.088L407.083 304.864V326.287H394.296L394.282 291.941Z"
      fill="#D6D6D6"
    />
    <path
      d="M456.2 291.941H469.358V307.322C469.358 311.442 471.199 316.55 479.88 316.55C488.56 316.55 490.36 311.51 490.36 307.322V291.941H503.477V308.324C503.477 314.985 500.331 326.836 480.855 326.836H479.001C459.016 326.836 456.2 314.985 456.2 308.324V291.941Z"
      fill="#D6D6D6"
    />
    <path d="M521.937 291.941V316.454H545.753V326.287H508.875V291.955L521.937 291.941Z" fill="#D6D6D6" />
    <path
      d="M583.745 320.752H564.145L561.508 326.245H548.212L565.203 291.914H582.839L600.804 326.245H586.492L583.745 320.752ZM573.773 300.346L568.142 312.156H579.625L573.773 300.346Z"
      fill="#D6D6D6"
    />
    <path
      d="M610.268 301.321H595.447V291.941H638.205V301.321H623.371V326.287H610.268V301.321Z"
      fill="#D6D6D6"
    />
    <path
      d="M667.749 291.296C689.904 291.296 692.775 301.815 692.775 308.324V309.698C692.775 316.125 689.959 326.918 667.749 326.918H665.675C643.411 326.918 640.595 316.125 640.595 309.698V308.324C640.595 301.815 643.411 291.296 665.675 291.296H667.749ZM666.692 300.524C656.349 300.524 654.179 305.001 654.179 308.654V309.203C654.179 312.815 656.528 317.649 666.692 317.649C676.856 317.649 679.205 312.952 679.205 309.299V308.654C679.205 305.001 676.883 300.524 666.692 300.524Z"
      fill="#D6D6D6"
    />
    <path
      d="M710.507 326.287H697.39V291.955H728.596C738.664 291.955 743.046 295.182 743.046 300.772V301.28C743.046 306.265 738.719 308.297 736.178 308.942C740.381 309.917 743.252 312.678 743.252 317.182V322.263C743.118 323.588 743.341 324.925 743.897 326.136V326.369H730.505C730.165 325.835 730.019 325.199 730.093 324.57V320.56C730.093 316.591 728.28 314.6 723.116 314.6H710.562L710.507 326.287ZM710.507 306.21H725.616C728.486 306.21 729.599 304.919 729.599 303.257C729.599 301.65 728.528 300.36 725.616 300.36H710.507V306.21Z"
      fill="#D6D6D6"
    />
    <path
      d="M813.287 298.561V298.478C814.236 297.484 815.542 296.907 816.916 296.875C818.29 296.843 819.621 297.358 820.615 298.307C821.61 299.255 822.186 300.56 822.219 301.934C822.251 303.308 821.736 304.639 820.787 305.633C820.726 305.7 820.662 305.764 820.595 305.825V305.894C819.614 306.824 818.309 307.334 816.958 307.315C815.606 307.296 814.316 306.75 813.362 305.792C812.408 304.835 811.866 303.543 811.852 302.192C811.838 300.84 812.353 299.537 813.287 298.561Z"
      fill="url(#paint0_linear_2281_70)"
    />
    <path
      d="M833.506 277.33L833.643 277.179C834.727 276.043 836.218 275.383 837.788 275.346C839.358 275.309 840.878 275.896 842.015 276.98C843.151 278.063 843.811 279.554 843.848 281.124C843.885 282.693 843.297 284.213 842.214 285.35L841.967 285.57L841.802 285.721C840.691 286.826 839.186 287.445 837.619 287.441C836.051 287.437 834.549 286.811 833.444 285.7C832.338 284.589 831.719 283.085 831.723 281.518C831.727 279.951 832.353 278.449 833.464 277.344L833.506 277.33Z"
      fill="url(#paint1_linear_2281_70)"
    />
    <path
      d="M853.792 256.141L853.944 255.976C854.536 255.297 855.259 254.746 856.071 254.355C856.882 253.964 857.764 253.741 858.664 253.701C859.564 253.66 860.462 253.803 861.305 254.119C862.149 254.436 862.919 254.92 863.569 255.543C864.22 256.166 864.738 256.914 865.091 257.742C865.444 258.57 865.626 259.462 865.625 260.362C865.624 261.263 865.44 262.154 865.085 262.981C864.73 263.809 864.21 264.556 863.558 265.177L863.325 265.41L863.174 265.561C861.904 266.704 860.244 267.315 858.537 267.269C856.83 267.223 855.205 266.523 854 265.314C852.794 264.105 852.098 262.478 852.057 260.771C852.016 259.064 852.632 257.406 853.779 256.141H853.792Z"
      fill="url(#paint2_linear_2281_70)"
    />
    <path
      d="M874.079 234.883L874.23 234.732C875.591 233.337 877.448 232.535 879.396 232.5C881.345 232.465 883.229 233.2 884.639 234.544C886.049 235.889 886.872 237.736 886.929 239.684C886.986 241.632 886.273 243.523 884.944 244.949L884.669 245.21L884.518 245.361C883.109 246.644 881.259 247.334 879.353 247.288C877.447 247.242 875.633 246.462 874.287 245.112C872.942 243.762 872.17 241.945 872.131 240.039C872.092 238.134 872.79 236.287 874.079 234.883Z"
      fill="url(#paint3_linear_2281_70)"
    />
    <path
      d="M894.38 213.638L894.531 213.474C896.04 211.991 898.067 211.153 900.183 211.139C902.299 211.124 904.337 211.933 905.867 213.395C907.397 214.856 908.298 216.856 908.379 218.969C908.46 221.083 907.715 223.146 906.302 224.721L906.013 225.009L905.849 225.146C904.302 226.565 902.267 227.33 900.17 227.283C898.072 227.236 896.073 226.38 894.592 224.894C893.111 223.408 892.262 221.406 892.222 219.309C892.183 217.211 892.956 215.179 894.38 213.638Z"
      fill="url(#paint4_linear_2281_70)"
    />
    <path
      d="M914.667 192.38L914.763 192.188C915.567 191.345 916.53 190.669 917.596 190.197C918.662 189.726 919.81 189.47 920.975 189.442C922.14 189.415 923.299 189.617 924.386 190.038C925.473 190.458 926.467 191.089 927.31 191.893C928.153 192.697 928.83 193.66 929.301 194.725C929.772 195.791 930.029 196.939 930.056 198.104C930.083 199.269 929.881 200.428 929.461 201.515C929.04 202.601 928.41 203.594 927.605 204.438C927.507 204.55 927.401 204.655 927.289 204.753L927.138 204.904C925.464 206.529 923.218 207.429 920.885 207.409C918.552 207.39 916.321 206.453 914.674 204.801C913.027 203.149 912.097 200.915 912.086 198.583C912.074 196.251 912.981 194.007 914.612 192.339L914.667 192.38Z"
      fill="url(#paint5_linear_2281_70)"
    />
    <path
      d="M934.967 171.136L935.118 170.971C936.88 169.117 939.305 168.039 941.862 167.973C944.418 167.908 946.896 168.86 948.75 170.621C950.605 172.382 951.683 174.807 951.749 177.363C951.815 179.919 950.862 182.397 949.101 184.251L948.757 184.594L948.593 184.745C946.763 186.414 944.359 187.313 941.882 187.254C939.406 187.195 937.048 186.182 935.3 184.427C933.552 182.673 932.549 180.311 932.499 177.835C932.45 175.358 933.359 172.959 935.036 171.136H934.967Z"
      fill="url(#paint6_linear_2281_70)"
    />
    <path
      d="M935.105 143.245L934.953 143.094C933.148 141.293 932.133 138.849 932.13 136.299C932.128 133.75 933.138 131.304 934.94 129.499C936.741 127.694 939.186 126.679 941.736 126.676C944.286 126.674 946.733 127.684 948.538 129.485L948.689 129.636C950.539 131.392 951.616 133.81 951.683 136.36C951.75 138.909 950.802 141.381 949.046 143.231C947.29 145.082 944.871 146.159 942.321 146.226C939.771 146.293 937.298 145.344 935.448 143.588L935.105 143.245Z"
      fill="url(#paint7_linear_2281_70)"
    />
    <path
      d="M955.46 164.229L955.296 164.064C953.379 162.153 952.301 159.56 952.297 156.855C952.293 154.15 953.364 151.553 955.275 149.638C957.186 147.722 959.779 146.644 962.485 146.64C965.191 146.636 967.788 147.707 969.704 149.617L969.869 149.782C971.721 151.663 972.771 154.19 972.795 156.83C972.819 159.47 971.815 162.016 969.997 163.93C968.179 165.844 965.687 166.977 963.049 167.089C960.411 167.201 957.833 166.284 955.859 164.531L955.46 164.229Z"
      fill="url(#paint8_linear_2281_70)"
    />
    <path
      d="M914.763 121.946L914.612 121.795C913.044 120.115 912.189 117.892 912.227 115.594C912.266 113.296 913.195 111.103 914.818 109.477C916.441 107.85 918.633 106.917 920.931 106.873C923.229 106.829 925.454 107.679 927.138 109.243L927.303 109.394C928.148 110.197 928.827 111.158 929.3 112.223C929.774 113.287 930.033 114.435 930.063 115.6C930.093 116.765 929.893 117.924 929.475 119.012C929.057 120.1 928.428 121.094 927.626 121.939C926.823 122.784 925.862 123.463 924.797 123.936C923.732 124.409 922.584 124.669 921.419 124.699C920.254 124.729 919.094 124.529 918.007 124.111C916.919 123.693 915.924 123.064 915.079 122.262L914.763 121.946Z"
      fill="url(#paint9_linear_2281_70)"
    />
    <path
      d="M894.517 100.647L894.366 100.496C892.84 98.9715 891.982 96.9035 891.98 94.7466C891.979 92.5897 892.835 90.5207 894.359 88.9947C895.884 87.4686 897.952 86.6106 900.11 86.6093C902.267 86.608 904.336 87.4636 905.863 88.9878L906.014 89.1388C906.788 89.8746 907.411 90.7558 907.845 91.732C908.279 92.7081 908.516 93.7603 908.544 94.8282C908.571 95.8962 908.388 96.9591 908.005 97.9563C907.621 98.9534 907.045 99.8653 906.309 100.64C905.573 101.414 904.692 102.036 903.715 102.471C902.739 102.905 901.687 103.142 900.619 103.169C899.55 103.197 898.487 103.014 897.49 102.63C896.493 102.247 895.581 101.671 894.806 100.935L894.517 100.647Z"
      fill="url(#paint10_linear_2281_70)"
    />
    <path
      d="M874.23 79.3613L874.079 79.1965C872.691 77.8089 871.912 75.9268 871.912 73.9644C871.912 72.002 872.691 70.1199 874.079 68.7323C875.467 67.3446 877.35 66.5651 879.312 66.5651C881.275 66.5651 883.158 67.3446 884.545 68.7323L884.71 68.8833C885.456 69.5431 886.062 70.3466 886.49 71.2457C886.918 72.1449 887.161 73.1212 887.203 74.1162C887.245 75.1113 887.085 76.1045 886.734 77.0365C886.383 77.9686 885.848 78.8202 885.16 79.5404C884.472 80.2606 883.646 80.8346 882.731 81.228C881.815 81.6214 880.83 81.8261 879.834 81.8299C878.838 81.8337 877.852 81.6365 876.933 81.2501C876.015 80.8636 875.185 80.296 874.491 79.581L874.23 79.3613Z"
      fill="url(#paint11_linear_2281_70)"
    />
    <path
      d="M853.943 58.0621L853.792 57.8973C853.175 57.2805 852.684 56.5481 852.35 55.7419C852.015 54.9358 851.842 54.0716 851.842 53.1987C851.841 52.3258 852.012 51.4614 852.346 50.6547C852.679 49.8481 853.169 49.115 853.785 48.4973C854.402 47.8797 855.135 47.3895 855.941 47.0549C856.748 46.7203 857.612 46.5477 858.485 46.5471C859.358 46.5465 860.223 46.7177 861.029 47.0512C861.836 47.3846 862.569 47.8737 863.187 48.4904L863.338 48.6415C864.053 49.2206 864.639 49.9413 865.062 50.7582C865.484 51.5751 865.732 52.4706 865.791 53.3882C865.85 54.3058 865.718 55.2257 865.404 56.0899C865.09 56.9541 864.6 57.744 863.966 58.4097C863.331 59.0753 862.566 59.6025 861.718 59.9579C860.87 60.3133 859.957 60.4892 859.037 60.4746C858.118 60.46 857.211 60.2552 856.375 59.8731C855.538 59.491 854.79 58.9398 854.177 58.2543L853.943 58.0621Z"
      fill="url(#paint12_linear_2281_70)"
    />
    <path
      d="M833.643 36.7628L833.492 36.6118C832.398 35.4992 831.787 33.9997 831.793 32.4394C831.799 30.8791 832.421 29.3843 833.523 28.2801C834.626 27.1759 836.12 26.5516 837.681 26.5432C839.241 26.5347 840.742 27.1427 841.857 28.2349L842.008 28.3859C842.574 28.9216 843.029 29.5634 843.348 30.275C843.666 30.9865 843.841 31.7538 843.863 32.5329C843.884 33.312 843.752 34.0878 843.474 34.8159C843.196 35.5441 842.777 36.2103 842.241 36.7765C841.705 37.3428 841.063 37.798 840.352 38.1162C839.64 38.4344 838.873 38.6093 838.093 38.631C837.314 38.6527 836.538 38.5207 835.81 38.2426C835.082 37.9644 834.415 37.5456 833.849 37.01L833.643 36.7628Z"
      fill="url(#paint13_linear_2281_70)"
    />
    <path
      d="M813.356 15.4636V15.395C812.422 14.4183 811.907 13.1152 811.921 11.764C811.935 10.4128 812.477 9.12054 813.43 8.16325C814.384 7.20596 815.675 6.65949 817.026 6.64053C818.378 6.62156 819.683 7.13162 820.663 8.06177C821.157 8.52975 821.555 9.09047 821.832 9.71192C822.11 10.3334 822.262 11.0034 822.28 11.6837C822.299 12.364 822.183 13.0413 821.94 13.6769C821.697 14.3125 821.33 14.894 820.862 15.3881C820.394 15.8822 819.833 16.2793 819.212 16.5568C818.59 16.8342 817.92 16.9865 817.24 17.005C816.559 17.0235 815.882 16.9078 815.246 16.6645C814.61 16.4213 814.029 16.0552 813.535 15.5872L813.356 15.4636Z"
      fill="url(#paint14_linear_2281_70)"
    />
    <path
      d="M767.013 303.491L767.096 303.422C767.564 302.921 768.127 302.518 768.752 302.237C769.378 301.955 770.053 301.801 770.738 301.782C771.423 301.764 772.106 301.881 772.745 302.129C773.385 302.376 773.969 302.747 774.464 303.222C774.958 303.697 775.354 304.265 775.627 304.893C775.901 305.522 776.046 306.199 776.056 306.884C776.066 307.57 775.939 308.25 775.684 308.887C775.428 309.523 775.049 310.102 774.568 310.59L774.389 310.769V310.837C773.415 311.806 772.095 312.348 770.721 312.345C769.347 312.341 768.031 311.791 767.062 310.817C766.093 309.843 765.55 308.523 765.554 307.149C765.558 305.776 766.108 304.459 767.082 303.491H767.013Z"
      fill="url(#paint15_linear_2281_70)"
    />
    <path
      d="M785.364 284.347L785.501 284.21C786.03 283.657 786.663 283.214 787.364 282.906C788.065 282.598 788.819 282.431 789.585 282.414C790.35 282.398 791.111 282.532 791.824 282.81C792.538 283.087 793.189 283.502 793.742 284.032C794.295 284.561 794.738 285.194 795.046 285.894C795.355 286.595 795.522 287.349 795.538 288.114C795.555 288.879 795.42 289.64 795.143 290.354C794.865 291.067 794.45 291.718 793.921 292.271L793.715 292.463L793.577 292.601C792.484 293.693 791.002 294.307 789.457 294.307C787.911 294.307 786.429 293.693 785.336 292.601C784.243 291.508 783.629 290.026 783.629 288.481C783.629 286.936 784.243 285.454 785.336 284.361L785.364 284.347Z"
      fill="url(#paint16_linear_2281_70)"
    />
    <path
      d="M803.783 265.135L803.92 264.998C805.107 263.758 806.739 263.04 808.456 263.003C810.173 262.966 811.834 263.612 813.074 264.799C814.315 265.986 815.033 267.618 815.07 269.334C815.107 271.051 814.461 272.712 813.274 273.952L813.04 274.172L812.903 274.309C811.679 275.485 810.043 276.133 808.346 276.114C806.649 276.095 805.027 275.41 803.831 274.206C802.634 273.003 801.959 271.378 801.95 269.681C801.941 267.984 802.599 266.352 803.783 265.135Z"
      fill="url(#paint17_linear_2281_70)"
    />
    <path
      d="M822.201 245.924L822.339 245.786C823.645 244.424 825.438 243.636 827.325 243.597C829.212 243.557 831.037 244.268 832.4 245.573C833.762 246.879 834.55 248.672 834.59 250.559C834.63 252.445 833.919 254.27 832.613 255.633C832.537 255.722 832.455 255.804 832.365 255.88L832.228 256.017C830.884 257.319 829.081 258.038 827.209 258.02C825.338 258.002 823.549 257.247 822.23 255.92C820.912 254.592 820.169 252.799 820.164 250.928C820.158 249.057 820.89 247.259 822.201 245.924Z"
      fill="url(#paint18_linear_2281_70)"
    />
    <path
      d="M840.593 226.712L840.73 226.574C842.17 225.148 844.11 224.34 846.138 224.323C848.165 224.306 850.118 225.081 851.582 226.483C853.045 227.886 853.903 229.804 853.972 231.83C854.041 233.856 853.316 235.828 851.952 237.327L851.691 237.588L851.54 237.725C850.067 239.103 848.116 239.854 846.099 239.821C844.083 239.787 842.158 238.971 840.732 237.545C839.306 236.119 838.49 234.195 838.456 232.179C838.422 230.162 839.174 228.212 840.552 226.739L840.593 226.712Z"
      fill="url(#paint19_linear_2281_70)"
    />
    <path
      d="M859.025 207.5L859.163 207.363C860.72 205.808 862.824 204.925 865.025 204.903C867.225 204.881 869.347 205.72 870.936 207.242C872.525 208.765 873.455 210.848 873.526 213.047C873.598 215.246 872.805 217.386 871.318 219.008L871.03 219.296L870.879 219.433C869.274 220.888 867.169 221.668 865.004 221.61C862.838 221.553 860.778 220.664 859.251 219.127C857.725 217.59 856.85 215.524 856.807 213.359C856.765 211.193 857.56 209.095 859.025 207.5Z"
      fill="url(#paint20_linear_2281_70)"
    />
    <path
      d="M877.444 188.288L877.582 188.151C878.399 187.265 879.384 186.552 880.48 186.051C881.576 185.551 882.761 185.274 883.965 185.237C885.169 185.2 886.369 185.403 887.494 185.835C888.619 186.266 889.646 186.918 890.516 187.751C891.386 188.585 892.081 189.583 892.561 190.688C893.041 191.793 893.295 192.983 893.31 194.187C893.324 195.392 893.098 196.587 892.645 197.704C892.192 198.82 891.521 199.835 890.671 200.689L890.355 201.004L890.204 201.142C888.476 202.714 886.208 203.559 883.873 203.499C881.537 203.44 879.315 202.481 877.669 200.823C876.023 199.165 875.081 196.936 875.039 194.601C874.997 192.265 875.859 190.004 877.444 188.288Z"
      fill="url(#paint21_linear_2281_70)"
    />
    <path
      d="M895.863 169.076L895.987 168.939C897.778 167.125 900.212 166.089 902.761 166.054C905.31 166.018 907.771 166.987 909.613 168.75C911.454 170.514 912.528 172.93 912.602 175.478C912.676 178.026 911.745 180.502 910.01 182.369L909.681 182.713L909.543 182.836C907.722 184.657 905.252 185.68 902.676 185.68C900.1 185.68 897.629 184.657 895.808 182.836C893.987 181.015 892.963 178.545 892.963 175.97C892.963 173.395 893.987 170.925 895.808 169.104L895.863 169.076Z"
      fill="url(#paint22_linear_2281_70)"
    />
    <path
      d="M914.419 150.166L914.57 150.015C916.439 148.067 919.006 146.94 921.705 146.884C924.405 146.827 927.016 147.845 928.965 149.713C930.914 151.582 932.04 154.148 932.097 156.847C932.154 159.545 931.136 162.156 929.267 164.105L928.91 164.448L928.773 164.599C926.858 166.502 924.266 167.567 921.567 167.559C918.867 167.552 916.281 166.472 914.378 164.558C912.475 162.644 911.41 160.053 911.418 157.354C911.425 154.655 912.505 152.069 914.419 150.166Z"
      fill="url(#paint23_linear_2281_70)"
    />
    <path
      d="M895.945 145.03L895.808 144.879C894.906 143.978 894.191 142.907 893.703 141.729C893.215 140.551 892.963 139.288 892.963 138.013C892.963 135.438 893.987 132.968 895.808 131.147C897.629 129.326 900.1 128.303 902.676 128.303C905.252 128.303 907.722 129.326 909.543 131.147L909.681 131.284C910.625 132.161 911.386 133.217 911.918 134.39C912.45 135.564 912.744 136.832 912.781 138.12C912.818 139.408 912.598 140.69 912.134 141.893C911.671 143.095 910.972 144.193 910.08 145.123C909.187 146.052 908.119 146.795 906.936 147.308C905.754 147.82 904.481 148.092 903.192 148.108C901.903 148.124 900.624 147.883 899.43 147.399C898.235 146.916 897.149 146.199 896.234 145.291L895.945 145.03Z"
      fill="url(#paint24_linear_2281_70)"
    />
    <path
      d="M877.54 125.558L877.403 125.407C875.713 123.702 874.769 121.396 874.779 118.996C874.79 116.596 875.753 114.298 877.458 112.608C879.163 110.918 881.469 109.974 883.87 109.985C886.271 109.995 888.569 110.958 890.259 112.663L890.397 112.8C891.308 113.611 892.047 114.597 892.568 115.7C893.089 116.802 893.383 117.999 893.431 119.218C893.478 120.437 893.28 121.652 892.846 122.793C892.413 123.933 891.754 124.974 890.908 125.853C890.063 126.733 889.049 127.432 887.926 127.911C886.804 128.389 885.597 128.636 884.377 128.636C883.157 128.637 881.949 128.391 880.827 127.914C879.704 127.437 878.689 126.738 877.843 125.86C877.735 125.766 877.634 125.665 877.54 125.558Z"
      fill="url(#paint25_linear_2281_70)"
    />
    <path
      d="M859.122 106.085L858.984 105.948C857.53 104.342 856.75 102.239 856.807 100.073C856.864 97.9082 857.754 95.8483 859.291 94.3221C860.828 92.7959 862.894 91.9208 865.06 91.8787C867.226 91.8366 869.325 92.6309 870.92 94.0963L871.071 94.2336C872.621 95.7931 873.499 97.8971 873.518 100.096C873.537 102.294 872.695 104.413 871.171 105.998C869.648 107.584 867.565 108.511 865.367 108.581C863.169 108.651 861.031 107.859 859.41 106.373C859.307 106.284 859.211 106.188 859.122 106.085Z"
      fill="url(#paint26_linear_2281_70)"
    />
    <path
      d="M840.717 86.6121L840.593 86.4473C839.136 84.9904 838.317 83.0145 838.317 80.9543C838.317 78.894 839.136 76.9181 840.593 75.4612C842.05 74.0044 844.026 73.1859 846.087 73.1859C848.148 73.1859 850.124 74.0044 851.581 75.4612L851.718 75.5986C852.454 76.3046 853.044 77.1486 853.454 78.0825C853.863 79.0163 854.085 80.0217 854.106 81.0412C854.127 82.0607 853.947 83.0744 853.576 84.0244C853.205 84.9743 852.651 85.842 851.945 86.5777C851.239 87.3135 850.395 87.903 849.461 88.3126C848.527 88.7222 847.521 88.9439 846.501 88.9649C845.482 88.9859 844.468 88.806 843.518 88.4353C842.567 88.0645 841.7 87.5104 840.964 86.8043L840.717 86.6121Z"
      fill="url(#paint27_linear_2281_70)"
    />
    <path
      d="M822.298 67.1393L822.16 67.002C820.831 65.6617 820.088 63.8482 820.096 61.9604C820.103 60.0727 820.861 58.2654 822.201 56.936C823.542 55.6066 825.356 54.8641 827.244 54.8719C829.132 54.8796 830.94 55.6369 832.269 56.9772L832.407 57.1145C833.769 58.422 834.556 60.2171 834.595 62.1048C834.634 63.9926 833.921 65.8183 832.613 67.1805C831.305 68.5426 829.51 69.3296 827.622 69.3682C825.733 69.4068 823.907 68.694 822.545 67.3865C822.456 67.3111 822.373 67.2284 822.298 67.1393Z"
      fill="url(#paint28_linear_2281_70)"
    />
    <path
      d="M803.892 47.6802L803.755 47.5292C802.542 46.3127 801.862 44.6643 801.865 42.9465C801.867 41.2287 802.552 39.5824 803.769 38.3695C804.985 37.1567 806.634 36.4768 808.352 36.4794C810.07 36.482 811.717 37.1668 812.93 38.3833L813.081 38.5206C814.32 39.7097 815.035 41.3421 815.07 43.0586C815.105 44.775 814.456 46.435 813.267 47.6733C812.077 48.9117 810.445 49.6269 808.728 49.6616C807.011 49.6964 805.351 49.0479 804.112 47.8587L803.892 47.6802Z"
      fill="url(#paint29_linear_2281_70)"
    />
    <path
      d="M785.474 28.2075L785.336 28.0564C784.795 27.5154 784.366 26.8731 784.073 26.1662C783.78 25.4594 783.629 24.7017 783.629 23.9366C783.629 22.3914 784.243 20.9095 785.336 19.8168C786.429 18.7242 787.911 18.1104 789.457 18.1104C791.002 18.1104 792.484 18.7242 793.577 19.8168L793.715 19.9542C794.835 21.0231 795.484 22.4932 795.52 24.041C795.556 25.5888 794.976 27.0875 793.907 28.2075C792.838 29.3274 791.367 29.9768 789.819 30.0129C788.271 30.0489 786.772 29.4687 785.652 28.3997L785.474 28.2075Z"
      fill="url(#paint30_linear_2281_70)"
    />
    <path
      d="M767.068 8.73465H766.986C766.057 7.75277 765.549 6.44669 765.57 5.09538C765.592 3.74408 766.141 2.45469 767.1 1.50265C768.06 0.550607 769.353 0.0113889 770.705 0.000178349C772.057 -0.0110323 773.359 0.506654 774.334 1.44265L774.417 1.51132C774.907 1.9829 775.3 2.54648 775.573 3.16989C775.846 3.79329 775.993 4.4643 776.006 5.14462C776.02 5.82493 775.899 6.50122 775.651 7.13487C775.403 7.76852 775.033 8.34712 774.561 8.83764C774.089 9.32816 773.526 9.721 772.902 9.99371C772.278 10.2664 771.607 10.4137 770.927 10.4271C770.246 10.4405 769.57 10.3197 768.936 10.0717C768.303 9.82377 767.724 9.45342 767.233 8.98184L767.068 8.73465Z"
      fill="url(#paint31_linear_2281_70)"
    />
    <path
      d="M787.026 242.834V242.751C787.493 242.246 788.055 241.838 788.68 241.551C789.305 241.263 789.98 241.101 790.667 241.074C791.355 241.047 792.041 241.156 792.686 241.395C793.332 241.633 793.924 241.996 794.429 242.463C794.934 242.93 795.342 243.492 795.63 244.117C795.918 244.742 796.08 245.417 796.106 246.104C796.133 246.792 796.024 247.477 795.786 248.123C795.548 248.768 795.184 249.36 794.717 249.865L794.415 250.153L794.333 250.222C793.345 251.111 792.053 251.586 790.725 251.549C789.397 251.513 788.133 250.967 787.196 250.025C786.259 249.083 785.72 247.816 785.691 246.488C785.662 245.16 786.145 243.871 787.039 242.889L787.026 242.834Z"
      fill="url(#paint32_linear_2281_70)"
    />
    <path
      d="M804.249 224.281L804.373 224.158C804.916 223.515 805.583 222.989 806.335 222.612C807.086 222.235 807.907 222.014 808.746 221.962C809.586 221.911 810.427 222.03 811.219 222.313C812.011 222.596 812.737 223.036 813.354 223.608C813.972 224.179 814.466 224.87 814.809 225.638C815.151 226.405 815.335 227.235 815.348 228.076C815.361 228.916 815.203 229.751 814.884 230.529C814.566 231.307 814.092 232.013 813.493 232.603L813.136 232.974L812.999 233.097C811.808 234.145 810.263 234.699 808.677 234.646C807.092 234.593 805.587 233.936 804.47 232.81C803.353 231.685 802.708 230.175 802.667 228.589C802.626 227.004 803.192 225.463 804.249 224.281Z"
      fill="url(#paint33_linear_2281_70)"
    />
    <path
      d="M821.501 205.687L821.625 205.55C822.932 204.139 824.747 203.304 826.67 203.231C828.593 203.158 830.466 203.851 831.878 205.159C833.29 206.466 834.124 208.281 834.197 210.203C834.271 212.126 833.577 213.999 832.269 215.41C832.132 215.561 831.995 215.698 831.844 215.836L831.706 215.959C830.32 217.188 828.517 217.839 826.665 217.781C824.814 217.722 823.055 216.957 821.75 215.643C820.445 214.33 819.692 212.566 819.645 210.715C819.599 208.864 820.263 207.065 821.501 205.687Z"
      fill="url(#paint34_linear_2281_70)"
    />
    <path
      d="M838.766 187.08L838.89 186.942C840.385 185.331 842.46 184.379 844.657 184.296C846.854 184.214 848.994 185.008 850.606 186.503C852.218 187.998 853.17 190.072 853.252 192.269C853.334 194.466 852.541 196.605 851.045 198.217L850.565 198.697L850.427 198.821C848.87 200.367 846.762 201.231 844.568 201.223C842.373 201.216 840.271 200.337 838.725 198.78C837.179 197.223 836.314 195.115 836.322 192.921C836.33 190.727 837.209 188.626 838.766 187.08Z"
      fill="url(#paint35_linear_2281_70)"
    />
    <path
      d="M856.017 168.472L856.155 168.335C857.838 166.514 860.175 165.436 862.653 165.338C865.131 165.24 867.547 166.13 869.368 167.813C871.189 169.495 872.268 171.833 872.365 174.31C872.463 176.788 871.573 179.202 869.89 181.023L869.34 181.559L869.203 181.683C867.423 183.279 865.098 184.132 862.708 184.063C860.318 183.995 858.045 183.011 856.359 181.315C854.674 179.619 853.704 177.341 853.651 174.951C853.597 172.561 854.464 170.241 856.072 168.472H856.017Z"
      fill="url(#paint36_linear_2281_70)"
    />
    <path
      d="M856.114 145.731L855.99 145.593C854.358 143.821 853.474 141.486 853.526 139.078C853.577 136.669 854.559 134.374 856.266 132.673C857.972 130.972 860.271 129.997 862.68 129.954C865.089 129.91 867.422 130.8 869.189 132.438L869.327 132.575C871.148 134.256 872.227 136.591 872.326 139.067C872.426 141.544 871.537 143.958 869.856 145.779C868.174 147.6 865.839 148.679 863.362 148.778C860.885 148.877 858.471 147.988 856.649 146.308C856.471 146.088 856.278 145.909 856.114 145.731Z"
      fill="url(#paint37_linear_2281_70)"
    />
    <path
      d="M873.461 163.995L873.324 163.844C871.659 161.904 870.79 159.405 870.892 156.851C870.993 154.296 872.058 151.875 873.873 150.073C875.687 148.271 878.116 147.223 880.672 147.138C883.227 147.054 885.72 147.939 887.65 149.617L887.801 149.754C889.617 151.612 890.651 154.097 890.688 156.695C890.725 159.293 889.763 161.806 888 163.715C886.237 165.624 883.808 166.783 881.215 166.952C878.622 167.122 876.062 166.29 874.065 164.627C873.846 164.393 873.64 164.187 873.461 163.995Z"
      fill="url(#paint38_linear_2281_70)"
    />
    <path
      d="M838.862 126.945L838.739 126.807C837.189 125.254 836.319 123.149 836.322 120.954C836.324 118.76 837.199 116.657 838.752 115.107C840.306 113.557 842.412 112.688 844.606 112.691C846.801 112.693 848.905 113.568 850.455 115.121L850.592 115.258C851.391 115.997 852.037 116.885 852.492 117.873C852.948 118.861 853.204 119.929 853.247 121.016C853.29 122.104 853.118 123.188 852.741 124.209C852.365 125.23 851.791 126.166 851.052 126.965C850.314 127.764 849.425 128.41 848.437 128.865C847.448 129.321 846.38 129.577 845.293 129.62C844.206 129.663 843.12 129.491 842.1 129.114C841.079 128.738 840.142 128.164 839.343 127.425C839.219 127.274 839.013 127.109 838.862 126.945Z"
      fill="url(#paint39_linear_2281_70)"
    />
    <path
      d="M821.611 108.172L821.473 108.035C820.212 106.656 819.533 104.843 819.576 102.975C819.619 101.107 820.381 99.3279 821.705 98.0084C823.028 96.689 824.81 95.9312 826.678 95.8931C828.547 95.855 830.358 96.5396 831.734 97.8041L831.871 97.9414C833.24 99.2577 834.037 101.058 834.092 102.956C834.148 104.854 833.456 106.697 832.167 108.091C830.877 109.485 829.092 110.317 827.196 110.409C825.299 110.501 823.442 109.846 822.023 108.584C821.885 108.419 821.734 108.31 821.611 108.172Z"
      fill="url(#paint40_linear_2281_70)"
    />
    <path
      d="M804.346 89.3998L804.222 89.2625C803.17 88.0756 802.612 86.5319 802.66 84.9469C802.709 83.362 803.361 81.8554 804.483 80.735C805.605 79.6146 807.113 78.965 808.699 78.919C810.284 78.873 811.827 79.434 813.012 80.4873L813.15 80.6247C814.32 81.7546 815.001 83.2979 815.047 84.9238C815.093 86.5496 814.5 88.1288 813.395 89.3229C812.291 90.517 810.762 91.2312 809.137 91.3123C807.513 91.3934 805.921 90.835 804.703 89.7568L804.346 89.3998Z"
      fill="url(#paint41_linear_2281_70)"
    />
    <path
      d="M787.094 70.6136C786.164 69.6334 785.654 68.3284 785.673 66.9773C785.692 65.6261 786.238 64.3359 787.196 63.3822C788.153 62.4285 789.446 61.8869 790.797 61.873C792.149 61.8591 793.452 62.3741 794.429 63.3079C794.969 63.7594 795.411 64.3159 795.729 64.9437C796.047 65.5714 796.234 66.2573 796.279 66.9595C796.324 67.6618 796.225 68.3659 795.99 69.0289C795.754 69.6919 795.386 70.3001 794.907 70.8164C794.429 71.3327 793.851 71.7465 793.208 72.0324C792.565 72.3184 791.87 72.4707 791.166 72.48C790.463 72.4893 789.764 72.3554 789.114 72.0865C788.463 71.8176 787.874 71.4193 787.383 70.9157L787.094 70.6136Z"
      fill="url(#paint42_linear_2281_70)"
    />
    <path
      d="M750.2 289.6V282.22H753.94C754.24 282.22 754.567 282.307 754.92 282.48C755.273 282.647 755.573 282.907 755.82 283.26C756.073 283.607 756.2 284.047 756.2 284.58C756.2 285.12 756.07 285.58 755.81 285.96C755.55 286.333 755.233 286.617 754.86 286.81C754.493 287.003 754.147 287.1 753.82 287.1H751.12V285.9H753.32C753.54 285.9 753.777 285.79 754.03 285.57C754.29 285.35 754.42 285.02 754.42 284.58C754.42 284.127 754.29 283.82 754.03 283.66C753.777 283.5 753.553 283.42 753.36 283.42H751.82V289.6H750.2ZM754.66 286.12L756.5 289.6H754.72L752.92 286.12H754.66ZM753 294C751.893 294 750.857 293.793 749.89 293.38C748.923 292.967 748.073 292.393 747.34 291.66C746.607 290.927 746.033 290.077 745.62 289.11C745.207 288.143 745 287.107 745 286C745 284.893 745.207 283.857 745.62 282.89C746.033 281.923 746.607 281.073 747.34 280.34C748.073 279.607 748.923 279.033 749.89 278.62C750.857 278.207 751.893 278 753 278C754.107 278 755.143 278.207 756.11 278.62C757.077 279.033 757.927 279.607 758.66 280.34C759.393 281.073 759.967 281.923 760.38 282.89C760.793 283.857 761 284.893 761 286C761 287.107 760.793 288.143 760.38 289.11C759.967 290.077 759.393 290.927 758.66 291.66C757.927 292.393 757.077 292.967 756.11 293.38C755.143 293.793 754.107 294 753 294ZM753 292.08C754.12 292.08 755.14 291.807 756.06 291.26C756.98 290.713 757.713 289.98 758.26 289.06C758.807 288.14 759.08 287.12 759.08 286C759.08 284.88 758.807 283.86 758.26 282.94C757.713 282.02 756.98 281.287 756.06 280.74C755.14 280.193 754.12 279.92 753 279.92C751.88 279.92 750.86 280.193 749.94 280.74C749.02 281.287 748.287 282.02 747.74 282.94C747.193 283.86 746.92 284.88 746.92 286C746.92 287.12 747.193 288.14 747.74 289.06C748.287 289.98 749.02 290.713 749.94 291.26C750.86 291.807 751.88 292.08 753 292.08Z"
      fill="#D6D6D6"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2281_70"
        x1="776.093"
        y1="302.104"
        x2="976.228"
        y2="302.104"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2281_70"
        x1="776.092"
        y1="281.395"
        x2="976.228"
        y2="281.395"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2281_70"
        x1="776.092"
        y1="260.659"
        x2="976.228"
        y2="260.659"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2281_70"
        x1="776.092"
        y1="239.923"
        x2="976.228"
        y2="239.923"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2281_70"
        x1="776.092"
        y1="219.173"
        x2="976.228"
        y2="219.173"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2281_70"
        x1="776.093"
        y1="198.436"
        x2="976.227"
        y2="198.436"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2281_70"
        x1="776.092"
        y1="177.7"
        x2="976.228"
        y2="177.7"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2281_70"
        x1="776.092"
        y1="136.544"
        x2="976.228"
        y2="136.544"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2281_70"
        x1="776.093"
        y1="157.143"
        x2="976.228"
        y2="157.143"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2281_70"
        x1="776.093"
        y1="115.766"
        x2="976.228"
        y2="115.766"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2281_70"
        x1="776.092"
        y1="94.9752"
        x2="976.228"
        y2="94.9752"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2281_70"
        x1="776.092"
        y1="74.1841"
        x2="976.228"
        y2="74.1841"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_2281_70"
        x1="776.092"
        y1="53.4067"
        x2="976.228"
        y2="53.4067"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_2281_70"
        x1="776.093"
        y1="32.6156"
        x2="976.228"
        y2="32.6156"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_2281_70"
        x1="776.092"
        y1="11.8657"
        x2="976.228"
        y2="11.8657"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_2281_70"
        x1="776.092"
        y1="307.047"
        x2="976.227"
        y2="307.047"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_2281_70"
        x1="776.092"
        y1="288.316"
        x2="976.228"
        y2="288.316"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_2281_70"
        x1="776.093"
        y1="269.544"
        x2="976.227"
        y2="269.544"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_2281_70"
        x1="776.092"
        y1="250.785"
        x2="976.228"
        y2="250.785"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_2281_70"
        x1="776.092"
        y1="232.026"
        x2="976.228"
        y2="232.026"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_2281_70"
        x1="776.093"
        y1="213.254"
        x2="976.228"
        y2="213.254"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_2281_70"
        x1="776.093"
        y1="194.495"
        x2="976.228"
        y2="194.495"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_2281_70"
        x1="776.092"
        y1="175.736"
        x2="976.228"
        y2="175.736"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_2281_70"
        x1="776.092"
        y1="157.143"
        x2="976.228"
        y2="157.143"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_2281_70"
        x1="776.092"
        y1="138.301"
        x2="976.228"
        y2="138.301"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_2281_70"
        x1="776.092"
        y1="119.268"
        x2="976.228"
        y2="119.268"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_2281_70"
        x1="776.093"
        y1="100.248"
        x2="976.228"
        y2="100.248"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_2281_70"
        x1="776.092"
        y1="81.2152"
        x2="976.228"
        y2="81.2152"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_2281_70"
        x1="776.092"
        y1="62.1956"
        x2="976.228"
        y2="62.1956"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_2281_70"
        x1="776.092"
        y1="43.1759"
        x2="976.227"
        y2="43.1759"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_2281_70"
        x1="776.092"
        y1="24.1426"
        x2="976.228"
        y2="24.1426"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_2281_70"
        x1="776.092"
        y1="5.15044"
        x2="976.228"
        y2="5.15044"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_2281_70"
        x1="776.092"
        y1="246.322"
        x2="976.229"
        y2="246.322"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_2281_70"
        x1="776.092"
        y1="228.456"
        x2="976.228"
        y2="228.456"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_2281_70"
        x1="776.092"
        y1="210.549"
        x2="976.228"
        y2="210.549"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_2281_70"
        x1="776.092"
        y1="192.655"
        x2="976.228"
        y2="192.655"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_2281_70"
        x1="776.092"
        y1="174.748"
        x2="976.228"
        y2="174.748"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_2281_70"
        x1="776.093"
        y1="139.373"
        x2="976.228"
        y2="139.373"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint38_linear_2281_70"
        x1="776.092"
        y1="157.088"
        x2="976.228"
        y2="157.088"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint39_linear_2281_70"
        x1="776.092"
        y1="121.287"
        x2="976.228"
        y2="121.287"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint40_linear_2281_70"
        x1="776.092"
        y1="103.215"
        x2="976.228"
        y2="103.215"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint41_linear_2281_70"
        x1="776.092"
        y1="85.1289"
        x2="976.227"
        y2="85.1289"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
      <linearGradient
        id="paint42_linear_2281_70"
        x1="776.093"
        y1="67.0844"
        x2="976.228"
        y2="67.0844"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#92A29C" />
        <stop offset="1" stopColor="#A8876C" />
      </linearGradient>
    </defs>
  </svg>
);

export const DashboardStatsChartImg: FC<DashboardStatsChart> = ({ color }) => (
  <svg width="52" height="36" viewBox="0 0 52 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 19.5C0 18.3954 0.895431 17.5 2 17.5V17.5C3.10457 17.5 4 18.3954 4 19.5V35.5H0V19.5Z"
      fill={color}
    />
    <path
      d="M8 2.5C8 1.39543 8.89543 0.5 10 0.5V0.5C11.1046 0.5 12 1.39543 12 2.5V35.5H8V2.5Z"
      fill={color}
    />
    <path
      d="M16 15.5C16 14.3954 16.8954 13.5 18 13.5V13.5C19.1046 13.5 20 14.3954 20 15.5V35.5H16V15.5Z"
      fill={color}
    />
    <path
      d="M24 15.5C24 14.3954 24.8954 13.5 26 13.5V13.5C27.1046 13.5 28 14.3954 28 15.5V35.5H24V15.5Z"
      fill={color}
    />
    <path
      d="M32 6.5C32 5.39543 32.8954 4.5 34 4.5V4.5C35.1046 4.5 36 5.39543 36 6.5V35.5H32V6.5Z"
      fill={color}
    />
    <path
      d="M40 17.5C40 16.3954 40.8954 15.5 42 15.5V15.5C43.1046 15.5 44 16.3954 44 17.5V35.5H40V17.5Z"
      fill={color}
    />
    <path
      d="M48 15.5C48 14.3954 48.8954 13.5 50 13.5V13.5C51.1046 13.5 52 14.3954 52 15.5V35.5H48V15.5Z"
      fill={color}
    />
  </svg>
);

export const TopContributorImg: FC<TopContributorColorType> = ({ color }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill={color} fillOpacity="0.08" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27 13H25V11H15V13H13C11.9 13 11 13.9 11 15V16C11 18.55 12.92 20.63 15.39 20.94C16.02 22.44 17.37 23.57 19 23.9V27H15V29H25V27H21V23.9C22.63 23.57 23.98 22.44 24.61 20.94C27.08 20.63 29 18.55 29 16V15C29 13.9 28.1 13 27 13ZM13 16V15H15V18.82C13.84 18.4 13 17.3 13 16ZM25 18.82C26.16 18.4 27 17.3 27 16V15H25V18.82Z"
      fill={color}
    />
  </svg>
);

export const NoDataFoundIcon: FC = () => {
  return (
    <svg width="356" height="260" viewBox="0 0 356 260" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.2">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.694458 143.564C0.694458 173.505 11.7357 200.789 29.9048 221.409C50.7489 245.072 80.9749 259.95 114.667 260C129.392 260.021 143.471 257.193 156.404 252.029C163.091 249.358 170.575 249.665 177.052 252.829C184.648 256.536 193.155 258.615 202.138 258.615C205.849 258.615 209.483 258.257 212.998 257.579C223.031 255.651 232.162 251.087 239.66 244.622C244.372 240.558 250.408 238.516 256.576 238.523H256.681C277.063 238.523 295.995 232.216 311.714 221.409C325.766 211.76 337.241 198.517 344.887 182.969C351.553 169.42 355.306 154.114 355.306 137.914C355.306 82.353 311.146 37.3052 256.681 37.3052C251.128 37.3052 245.688 37.7836 240.381 38.6763C226.329 15.47 201.165 0 172.458 0C160.338 0 148.848 2.75722 138.563 7.69978C128.782 12.3849 120.086 19.0423 112.972 27.1556C88.8163 27.5484 66.4807 35.5983 48.1998 49.0327C19.4234 70.1677 0.694458 104.637 0.694458 143.564Z"
          fill="url(#paint0_linear_2795_33279)"
        />
      </g>
      <path
        opacity="0.15"
        d="M82.7788 101.288C100.986 101.288 115.745 86.859 115.745 69.06C115.745 51.261 100.986 36.832 82.7788 36.832C64.5719 36.832 49.8123 51.261 49.8123 69.06C49.8123 86.859 64.5719 101.288 82.7788 101.288Z"
        fill="#FFC107"
      />
      <path
        d="M82.7788 85.9651C92.3288 85.9651 100.071 78.3967 100.071 69.0607C100.071 59.7246 92.3288 52.1562 82.7788 52.1562C73.2288 52.1562 65.487 59.7246 65.487 69.0607C65.487 78.3967 73.2288 85.9651 82.7788 85.9651Z"
        fill="url(#paint1_linear_2795_33279)"
      />
      <path
        d="M181.604 131.055C207.135 131.055 227.832 151.288 227.832 176.248C227.832 201.208 207.135 221.442 181.604 221.442C156.072 221.442 135.374 201.208 135.374 176.248C135.374 151.288 156.072 131.055 181.604 131.055ZM181.604 147.8C165.532 147.8 152.504 160.537 152.504 176.248C152.504 191.96 165.532 204.696 181.604 204.696C197.675 204.696 210.703 191.96 210.703 176.248C210.703 160.537 197.675 147.8 181.604 147.8Z"
        fill="#7F6D41"
      />
      <path
        d="M129.954 191.093C129.954 188.108 128.852 187.031 125.789 187.031H117.387V138.923C117.387 135.69 116.285 134.852 113.222 134.852H106.446C104.134 134.844 101.955 135.909 100.574 137.722L59.9193 187.031C58.8996 188.465 58.3917 190.188 58.4738 191.933V196.243C58.4738 199.236 59.576 200.314 62.6296 200.314H103.023V215.991C103.023 218.976 104.125 220.054 107.178 220.054H113.177C116.24 220.054 117.342 218.976 117.342 215.991V200.314H125.789C129.05 200.314 129.954 199.236 129.954 196.243V191.093ZM76.4519 187.031L103.023 154.953V187.031H76.4519Z"
        fill="#B3995B"
      />
      <path
        d="M304.779 191.093C304.779 188.108 303.676 187.031 300.613 187.031H292.176V138.923C292.176 135.69 291.074 134.852 288.011 134.852H281.28C278.968 134.844 276.789 135.909 275.408 137.722L234.753 187.031C233.727 188.463 233.212 190.186 233.29 191.933V196.243C233.29 199.236 234.391 200.314 237.445 200.314H277.847V215.991C277.847 218.976 278.949 220.054 282.003 220.054H288.002C291.064 220.054 292.166 218.976 292.166 215.991V200.314H300.613C303.92 200.314 304.779 199.236 304.779 196.243V191.093ZM251.277 187.031L277.847 154.953V187.031H251.277Z"
        fill="#B3995B"
      />
      <path
        opacity="0.24"
        d="M315.132 104.658C315.132 101.36 312.398 98.687 309.024 98.687C308.695 98.687 308.365 98.713 308.04 98.7665C306.612 96.1614 303.836 94.5335 300.812 94.527H300.514C301.496 90.6692 299.932 86.6202 296.587 84.3595C293.242 82.0989 288.814 82.0989 285.469 84.3595C282.124 86.6202 280.56 90.6692 281.542 94.527H281.244C278.237 94.4295 275.415 95.9426 273.882 98.4733C272.349 101.004 272.349 104.151 273.882 106.681C275.415 109.213 278.237 110.725 281.244 110.628H309.82V110.575C312.856 110.181 315.127 107.652 315.132 104.658Z"
        fill="#B3995B"
      />
      <path
        opacity="0.5"
        d="M227 64.6691C227 60.0706 223.195 56.3433 218.501 56.3433C218.043 56.3433 217.584 56.3796 217.132 56.4541C215.144 52.8215 211.282 50.5515 207.074 50.5424H206.66C208.026 45.1628 205.85 39.5166 201.195 36.3643C196.54 33.2119 190.379 33.2119 185.724 36.3643C181.069 39.5166 178.893 45.1628 180.259 50.5424H179.845C175.66 50.4064 171.733 52.5163 169.6 56.0452C167.467 59.5741 167.467 63.9621 169.6 67.491C171.733 71.0209 175.66 73.1298 179.845 72.9938H219.609V72.9203C223.834 72.3714 226.993 68.8445 227 64.6691Z"
        fill="#B3995B"
      />
      <path
        opacity="0.24"
        d="M77.7175 143.755C77.7175 142.396 77.1649 141.094 76.1823 140.133C75.1997 139.172 73.8669 138.633 72.4772 138.633C72.1959 138.638 71.9151 138.662 71.637 138.703C70.4049 136.464 68.0129 135.069 65.4123 135.073H65.1594C66.0109 131.762 64.6731 128.281 61.8016 126.337C58.9301 124.393 55.1267 124.393 52.2552 126.337C49.3837 128.281 48.0459 131.762 48.8974 135.073H48.6445C46.0618 134.983 43.6348 136.278 42.3161 138.451C40.9973 140.624 40.9973 143.327 42.3161 145.5C43.6348 147.673 46.0618 148.968 48.6445 148.878H73.1548V148.834C75.7619 148.497 77.7123 146.326 77.7175 143.755Z"
        fill="#B3995B"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2795_33279"
          x1="243.61"
          y1="306.245"
          x2="369.2"
          y2="16.7024"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#B3995B" stopOpacity="0.6" />
          <stop offset="1" stopColor="#B3995B" stopOpacity="0.01" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2795_33279"
          x1="48.1953"
          y1="69.0607"
          x2="81.9953"
          y2="103.636"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFE16A" />
          <stop offset="1" stopColor="#B78103" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const AccessDeniedIcon: FC = () => {
  return (
    <svg width="348" height="260" viewBox="0 0 348 260" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.2">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666748 143.564C0.666748 173.505 11.4606 200.789 29.2227 221.409C49.5998 245.072 79.1486 259.95 112.086 260C126.481 260.021 140.245 257.193 152.888 252.029C159.425 249.358 166.742 249.665 173.073 252.829C180.5 256.536 188.816 258.615 197.597 258.615C201.225 258.615 204.777 258.257 208.214 257.579C218.022 255.651 226.948 251.087 234.278 244.622C238.885 240.558 244.785 238.516 250.815 238.523H250.918C270.843 238.523 289.352 232.216 304.718 221.409C318.456 211.76 329.674 198.517 337.148 182.969C343.665 169.42 347.333 154.114 347.333 137.914C347.333 82.353 304.163 37.3052 250.918 37.3052C245.49 37.3052 240.172 37.7836 234.984 38.6763C221.246 15.47 196.646 0 168.582 0C156.734 0 145.501 2.75722 135.447 7.69978C125.885 12.3849 117.383 19.0423 110.429 27.1556C86.8144 27.5484 64.9792 35.5983 47.1078 49.0327C18.9761 70.1677 0.666748 104.637 0.666748 143.564Z"
          fill="url(#paint0_linear_2795_33314)"
        />
      </g>
      <path
        d="M202.306 142.319C201.905 141.785 201.402 141.334 200.827 140.994C200.252 140.654 199.615 140.43 198.954 140.336C198.292 140.242 197.618 140.28 196.971 140.446C196.324 140.613 195.715 140.905 195.181 141.307L184.25 149.5V111.063C184.25 109.82 183.756 108.627 182.877 107.748C181.998 106.869 180.806 106.375 179.563 106.375C178.319 106.375 177.127 106.869 176.248 107.748C175.369 108.627 174.875 109.82 174.875 111.063V105.438C174.877 104.822 174.757 104.211 174.522 103.642C174.287 103.072 173.942 102.555 173.506 102.119C173.071 101.683 172.553 101.338 171.984 101.103C171.414 100.868 170.804 100.748 170.188 100.75C169.898 100.747 169.609 100.772 169.325 100.825H169.288C168.22 101.037 167.259 101.613 166.569 102.454C165.878 103.295 165.5 104.35 165.5 105.438V111.063C165.5 109.82 165.006 108.627 164.127 107.748C163.248 106.869 162.056 106.375 160.813 106.375C160.529 106.372 160.247 106.397 159.969 106.45H159.95C158.873 106.649 157.9 107.22 157.201 108.063C156.502 108.906 156.121 109.968 156.125 111.063V116.688C156.127 116.072 156.007 115.461 155.772 114.892C155.537 114.322 155.192 113.805 154.756 113.369C154.321 112.933 153.803 112.588 153.234 112.353C152.664 112.118 152.054 111.998 151.438 112C151.148 111.997 150.859 112.022 150.575 112.075C149.501 112.28 148.532 112.853 147.834 113.694C147.136 114.536 146.752 115.594 146.75 116.688V157C146.747 159.577 147.283 162.125 148.325 164.482C149.776 167.831 152.175 170.683 155.227 172.685C158.279 174.688 161.85 175.753 165.5 175.75H168.631C171.194 175.751 173.729 175.226 176.081 174.207C178.432 173.188 180.549 171.696 182.3 169.825L201.95 148.863C202.835 147.918 203.325 146.67 203.319 145.375C203.317 144.275 202.962 143.203 202.306 142.319Z"
        fill="#FBCDBE"
      />
      <path
        d="M169.25 82C158.125 82 147.249 85.299 137.999 91.4798C128.749 97.6607 121.539 106.446 117.282 116.724C113.024 127.002 111.91 138.312 114.081 149.224C116.251 160.135 121.609 170.158 129.475 178.025C137.342 185.891 147.365 191.249 158.276 193.419C169.188 195.59 180.498 194.476 190.776 190.218C201.054 185.961 209.839 178.751 216.02 169.501C222.201 160.251 225.5 149.375 225.5 138.25C225.5 123.332 219.574 109.024 209.025 98.4752C198.476 87.9263 184.168 82 169.25 82ZM120.759 138.25C120.755 128.99 123.404 119.922 128.392 112.12C133.38 104.318 140.499 98.1081 148.906 94.2251C157.313 90.3421 166.656 88.9485 175.83 90.2091C185.004 91.4698 193.625 95.332 200.673 101.339L132.339 169.673C124.844 160.921 120.736 149.772 120.759 138.25ZM169.25 186.741C157.728 186.764 146.579 182.656 137.827 175.161L206.161 106.827C212.168 113.875 216.03 122.496 217.291 131.67C218.552 140.844 217.158 150.187 213.275 158.594C209.392 167.001 203.182 174.12 195.38 179.108C187.578 184.096 178.51 186.745 169.25 186.741Z"
        fill="#B3995B"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2795_33314"
          x1="238.141"
          y1="306.245"
          x2="365.673"
          y2="18.8124"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#B3995B" />
          <stop offset="1" stopColor="#B3995B" stopOpacity="0.01" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BottleIcon = (
  <svg width="24" height="24" viewBox="0 0 512 512" fill="none">
    <g>
      <g>
        <g>
          <path
            d="M401.232,178.711l-63.822-75.578h18.015c6.888,0,12.47-5.583,12.47-12.47V12.47c0-6.888-5.582-12.47-12.47-12.47H156.576
         c-6.888,0-12.47,5.582-12.47,12.47v78.192c0,6.887,5.582,12.47,12.47,12.47h18.013l-63.822,75.578
         c-1.9,2.251-2.943,5.099-2.943,8.046c0,14.625,0,302.44,0,312.772c0,6.887,5.583,12.47,12.47,12.47h271.408
         c6.888,0,12.47-5.583,12.47-12.47c0-16.572,0-300.944,0-312.772C404.175,183.812,403.132,180.962,401.232,178.711z
          M169.046,78.192V24.94h173.909v53.252C309.454,78.192,206.887,78.192,169.046,78.192z M379.235,487.06H132.767v-59.682h246.468
         V487.06z M379.235,402.438H132.767V260.07h246.468V402.438z M379.235,235.13H132.767v-43.813l74.468-88.185h97.532l74.468,88.185
         V235.13z"
          />
          <path
            d="M214.86,347.555h20.118c2.609,0,4.724,2.115,4.724,4.724v20.118c0,2.609,2.115,4.724,4.724,4.724h23.151
         c2.609,0,4.724-2.115,4.724-4.724v-20.118c0-2.609,2.115-4.724,4.725-4.724h20.118c2.609,0,4.724-2.115,4.724-4.724V319.68
         c0-2.609-2.115-4.724-4.724-4.724h-20.118c-2.609,0-4.725-2.115-4.725-4.724v-20.118c0-2.609-2.115-4.724-4.724-4.724h-23.151
         c-2.609,0-4.724,2.115-4.724,4.724v20.118c0,2.609-2.115,4.724-4.724,4.724H214.86c-2.609,0-4.724,2.115-4.724,4.724v23.151
         C210.136,345.44,212.251,347.555,214.86,347.555z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const SweetenerIcon = (
  <svg
    fill="#000000"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 308.752 308.752"
    enableBackground="new 0 0 308.752 308.752">
    <path d="m271.043,176.565h-19.334v-11.5c0-6.996-5.671-12.667-12.667-12.667h-68.634c1.653-19.838 6.28-38.582 10.834-50.225l50.739,22.249c10.196,4.477 22.091-0.15 26.569-10.368l23.294-53.118c4.474-10.205-0.161-22.092-10.371-26.566l-74.485-32.664c-10.207-4.477-22.094,0.159-26.569,10.37l-12.687,28.934c-1.21,2.755-1.524,5.768-0.908,8.711l2.183,10.433c0.879,4.193 3.557,7.746 7.344,9.746l.631,.333 .458,6.887 2.806,7.187c-15.144,19.94-25.036,44.175-32.11,68.091h-68.427c-6.996,0-12.667,5.671-12.667,12.667v11.5h-19.333c-9.665,0-17.5,7.835-17.5,17.5s7.835,17.5 17.5,17.5h19.334c0,55.922 45.001,97.188 97.333,97.188 52.217,0 97.333-41.159 97.333-97.188h19.334c9.665,0 17.5-7.835 17.5-17.5s-7.835-17.5-17.5-17.5zm-79.67-150.023l65.634,28.781-19.411,44.264-41.685-18.279-3.783-9.692-.599-8.979c-0.334-5-3.179-9.385-7.616-11.733l-1.463-.772-.459-2.194 9.382-21.396zm35.336,186.033c0,39.247-32.449,71.177-72.333,71.177s-72.333-31.93-72.333-71.177v-35.177h144.667v35.177z" />
  </svg>
);

export const SyrupIcon = <VaccinesIcon />;

export const DownFallIcon: FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle opacity="0.16" cx="12" cy="12" r="12" fill="#FF4842" />
      <path
        d="M18 12C18 11.6318 17.7015 11.3333 17.3333 11.3333C16.9651 11.3333 16.6667 11.6318 16.6667 12V13.5333L13.84 10.2C13.6293 9.95375 13.2721 9.89467 12.9933 10.06L10.1467 11.8L7.17999 8.24C7.02755 8.0566 6.78886 7.96846 6.55382 8.00877C6.31877 8.04909 6.12309 8.21173 6.04048 8.43544C5.95787 8.65915 6.00089 8.90994 6.15332 9.09333L9.48665 13.0933C9.69633 13.3454 10.0582 13.4076 10.34 13.24L13.1933 11.5267L15.86 14.6667H14C13.6318 14.6667 13.3333 14.9651 13.3333 15.3333C13.3333 15.7015 13.6318 16 14 16H17.3333C17.4154 15.998 17.4965 15.9822 17.5733 15.9533L17.6667 15.9C17.7014 15.8825 17.7348 15.8624 17.7667 15.84C17.8032 15.807 17.8346 15.7688 17.86 15.7267C17.8823 15.6971 17.9024 15.6659 17.92 15.6333C17.9363 15.5973 17.9475 15.5591 17.9533 15.52C17.9804 15.4612 17.9962 15.3979 18 15.3333V12Z"
        fill="#FF4842"
      />
    </svg>
  );
};

export const GrowthIcon: FC = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
      <circle opacity="0.16" cx="12.25" cy="12" r="12" fill="#54D62C" />
      <path
        d="M18.25 8.66667C18.2563 8.62021 18.2563 8.57312 18.25 8.52667C18.2442 8.48753 18.2329 8.44938 18.2166 8.41333C18.199 8.38075 18.179 8.34955 18.1566 8.32C18.1313 8.27784 18.0998 8.23965 18.0633 8.20667L17.9833 8.16C17.9448 8.1313 17.9021 8.10881 17.8566 8.09333H17.7233C17.6827 8.054 17.6352 8.02237 17.5833 8H14.25C13.8818 8 13.5833 8.29848 13.5833 8.66667C13.5833 9.03486 13.8818 9.33333 14.25 9.33333H16.1366L13.47 12.4733L10.59 10.76C10.3081 10.5924 9.9463 10.6546 9.73662 10.9067L6.40329 14.9067C6.28992 15.0427 6.23534 15.2183 6.2516 15.3946C6.26786 15.571 6.35362 15.7336 6.48995 15.8467C6.6099 15.9461 6.76085 16.0003 6.91662 16C7.11491 16.0003 7.30305 15.9124 7.42995 15.76L10.3966 12.2L13.2433 13.9067C13.522 14.072 13.8793 14.0129 14.09 13.7667L16.9166 10.4667V12C16.9166 12.3682 17.2151 12.6667 17.5833 12.6667C17.9515 12.6667 18.25 12.3682 18.25 12V8.66667Z"
        fill="#54D62C"
      />
    </svg>
  );
};

// capsule type icons
export const CapsuleTypeIcon: FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_791_15385)">
        <path
          d="M14.1723 7.10012L7.10029 14.1731C6.72885 14.5446 6.28788 14.8392 5.80257 15.0402C5.31725 15.2413 4.79709 15.3447 4.27179 15.3447C3.74649 15.3447 3.22633 15.2413 2.74102 15.0402C2.2557 14.8392 1.81474 14.5446 1.44329 14.1731C1.07185 13.8017 0.777204 13.3607 0.57618 12.8754C0.375156 12.3901 0.271689 11.8699 0.271689 11.3446C0.271689 10.8193 0.375155 10.2992 0.57618 9.81385C0.777204 9.32854 1.07185 8.88757 1.44329 8.51612L8.51329 1.44512C8.88461 1.07348 9.32548 0.778615 9.81075 0.577359C10.296 0.376103 10.8162 0.272398 11.3415 0.272166C11.8669 0.271934 12.3871 0.37518 12.8726 0.576007C13.358 0.776834 13.7992 1.07131 14.1708 1.44262C14.5424 1.81394 14.8373 2.25481 15.0386 2.74008C15.2398 3.22535 15.3435 3.74551 15.3437 4.27085C15.344 4.7962 15.2407 5.31645 15.0399 5.8019C14.8391 6.28734 14.5436 6.72848 14.1723 7.10012ZM5.04429 6.32912L2.15129 9.22212C1.86903 9.4999 1.64455 9.83081 1.49081 10.1958C1.33707 10.5607 1.25711 10.9525 1.25554 11.3485C1.25398 11.7446 1.33084 12.137 1.48169 12.5031C1.63253 12.8693 1.85439 13.202 2.13445 13.482C2.41451 13.762 2.74724 13.9837 3.11344 14.1345C3.47964 14.2853 3.87207 14.362 4.26809 14.3604C4.66411 14.3587 5.05588 14.2787 5.4208 14.1248C5.78573 13.971 6.11659 13.7465 6.39429 13.4641L9.28729 10.5711L5.04429 6.32912Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_791_15385">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BaseCoatingIcon: FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M17.0408 10.6406L9.69083 3.29062L8.82083 2.42063C8.53083 2.13063 8.05083 2.13063 7.76083 2.42063C7.47083 2.71062 7.47083 3.19062 7.76083 3.48062L8.63083 4.35062L3.00083 9.98062C2.36083 10.6206 2.02083 11.2706 2.00083 11.9206C1.98083 12.6106 2.32083 13.3006 3.00083 13.9906L7.01083 18.0006C8.35083 19.3306 9.69083 19.3306 11.0208 18.0006L17.0408 11.9806C17.2408 11.7806 17.3308 11.5106 17.3108 11.2506C17.3008 11.0306 17.2008 10.8006 17.0408 10.6406Z"
        fill="#292D32"
      />
      <path
        d="M16 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H16C16.41 21.25 16.75 21.59 16.75 22C16.75 22.41 16.41 22.75 16 22.75Z"
        fill="#292D32"
      />
      <path
        d="M19.35 14.7803C19.09 14.5003 18.61 14.5003 18.35 14.7803C18.04 15.1203 16.5 16.8503 16.5 18.1703C16.5 19.4703 17.55 20.5203 18.85 20.5203C20.15 20.5203 21.2 19.4703 21.2 18.1703C21.2 16.8603 19.66 15.1203 19.35 14.7803Z"
        fill="#292D32"
      />
    </svg>
  );
};
export const VisaIcon = (
  <svg width="36px" height="24px" viewBox="0 0 24 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="319" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="New-Icons" transform="translate(-80.000000, -280.000000)" fillRule="nonzero">
        <g id="Card-Brands" transform="translate(40.000000, 200.000000)">
          <g id="Color" transform="translate(0.000000, 80.000000)">
            <g id="Visa" transform="translate(40.000000, 0.000000)">
              <rect
                id="Container"
                strokeOpacity="0.2"
                stroke="#000000"
                strokeWidth="0.5"
                fill="#FFFFFF"
                x="0.25"
                y="0.25"
                width="23.5"
                height="15.5"
                rx="2"></rect>
              <path
                d="M2.78773262,5.91443732 C2.26459089,5.62750595 1.6675389,5.39673777 1,5.23659312 L1.0280005,5.1118821 L3.76497922,5.1118821 C4.13596254,5.12488556 4.43699113,5.23650585 4.53494636,5.63071135 L5.12976697,8.46659052 L5.31198338,9.32072617 L6.97796639,5.1118821 L8.77678896,5.1118821 L6.10288111,11.2775284 L4.30396552,11.2775284 L2.78773262,5.91443732 L2.78773262,5.91443732 Z M10.0999752,11.2840738 L8.39882877,11.2840738 L9.46284763,5.1118821 L11.163901,5.1118821 L10.0999752,11.2840738 Z M16.2667821,5.26277458 L16.0354292,6.59558538 L15.881566,6.53004446 C15.5737466,6.40524617 15.1674138,6.28053516 14.6143808,6.29371316 C13.942741,6.29371316 13.6415263,6.56277129 13.6345494,6.82545859 C13.6345494,7.11441463 13.998928,7.3048411 14.5939153,7.58725177 C15.5740257,8.02718756 16.0286384,8.56556562 16.0218476,9.26818871 C16.0080799,10.5486366 14.8460128,11.376058 13.0610509,11.376058 C12.2978746,11.3694253 11.5627918,11.2180965 11.163808,11.0475679 L11.4018587,9.66204513 L11.6258627,9.76066195 C12.1788958,9.99070971 12.5428092,10.0889775 13.221984,10.0889775 C13.7117601,10.0889775 14.2368857,9.89837643 14.2435835,9.48488392 C14.2435835,9.21565125 14.0198586,9.01850486 13.3617074,8.7164581 C12.717789,8.42086943 11.8568435,7.92848346 11.8707973,7.04197926 C11.8780532,5.84042483 13.0610509,5 14.7409877,5 C15.3990458,5 15.9312413,5.13788902 16.2667821,5.26277458 Z M18.5277524,9.0974856 L19.941731,9.0974856 C19.8717762,8.78889347 19.549631,7.31147374 19.549631,7.31147374 L19.4307452,6.77964104 C19.3467437,7.00942698 19.1998574,7.38373457 19.2069273,7.37055657 C19.2069273,7.37055657 18.6678479,8.74290137 18.5277524,9.0974856 Z M20.6276036,5.1118821 L22,11.2839865 L20.4249023,11.2839865 C20.4249023,11.2839865 20.2707601,10.5748181 20.221922,10.3581228 L18.0377903,10.3581228 C17.9746264,10.5221933 17.6807607,11.2839865 17.6807607,11.2839865 L15.8957988,11.2839865 L18.4226343,5.62399144 C18.5977072,5.22341512 18.9059917,5.1118821 19.3117663,5.1118821 L20.6276036,5.1118821 L20.6276036,5.1118821 Z"
                id="Shape"
                fill="#1434CB"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const MasterCardIcon = (
  <svg height="24" viewBox="0 0 24 16" width="36" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <rect fill="#252525" height="16" rx="2" width="24" />
      <circle cx="9" cy="8" fill="#eb001b" r="5" />
      <circle cx="15" cy="8" fill="#f79e1b" r="5" />
      <path
        d="m12 3.99963381c1.2144467.91220633 2 2.36454836 2 4.00036619s-.7855533 3.0881599-2 4.0003662c-1.2144467-.9122063-2-2.36454837-2-4.0003662s.7855533-3.08815986 2-4.00036619z"
        fill="#ff5f00"
      />
    </g>
  </svg>
);

export const AmericanExpressIcon = (
  <svg height="24" viewBox="0 0 24 16" width="36" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <rect fill="#016fd0" height="16" rx="2" width="24" />
      <path
        d="m13.7640663 13.3938564v-5.70139231l10.1475359.00910497v1.57489503l-1.1728619 1.25339231 1.1728619 1.2648839v1.6083094h-1.8726188l-.9951823-1.0981657-.9881105 1.1023204z"
        fill="#fffffe"
      />
      <path
        d="m14.4418122 12.7687956v-4.448884h3.7722872v1.02488398h-2.550895v.69569062h2.4900774v1.0078232h-2.4900774v.6833149h2.550895v1.0371713z"
        fill="#016fd0"
      />
      <path
        d="m18.1952707 12.7687956 2.087337-2.2270055-2.0874254-2.2217901h1.6156464l1.2754917 1.41003315 1.2791161-1.41003315h1.5461657v.03500552l-2.0428729 2.18678458 2.0428729 2.1638895v.063116h-1.5617237l-1.2981216-1.4241768-1.2847735 1.4241768z"
        fill="#016fd0"
      />
      <path
        d="m14.2373481 2.6319558h2.4460552l.8591381 1.95085083v-1.95085083h3.0198453l.5207514 1.46156906.5225194-1.46156906h2.3059447v5.70139227h-12.1865193z"
        fill="#fffffe"
      />
      <g fill="#016fd0">
        <path d="m14.7004641 3.25135912-1.9740111 4.44517127h1.3539006l.3724199-.89016575h2.0179447l.3721547.89016575h1.3875801l-1.96579-4.44517127zm.1696353 2.55743646.592-1.41507182.5915581 1.41507182z" />
        <path d="m18.2119779 7.69573481v-4.44508288l1.903116.00654144.9792707 2.73272928.9856354-2.73927072h1.8316022v4.44508288l-1.1786077.01043094v-3.05334807l-1.1125746 3.04291713h-1.0758011l-1.1356464-3.05334807v3.05334807z" />
      </g>
    </g>
  </svg>
);

export const DiscoverIcon = (
  <svg width="36px" height="24px" viewBox="0 0 24 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="319" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="New-Icons" transform="translate(-280.000000, -280.000000)" fillRule="nonzero">
        <g id="Card-Brands" transform="translate(40.000000, 200.000000)">
          <g id="Color" transform="translate(0.000000, 80.000000)">
            <g id="Discover" transform="translate(240.000000, 0.000000)">
              <path
                d="M21.9972414,15.749927 L21.999381,15.7499362 C22.9544683,15.7581106 23.73806,14.9772525 23.75,14.0041555 L23.7500083,2.00630219 C23.7461702,1.53568921 23.5588633,1.08617106 23.2297297,0.756801782 C22.9014319,0.428268884 22.4589161,0.246148853 21.9972414,0.250070854 L2.00063,0.250061791 C1.54108393,0.246148853 1.09856813,0.428268884 0.77027028,0.756801782 C0.441136651,1.08617106 0.253829819,1.53568921 0.25,2.00426336 L0.249991686,13.9936957 C0.253829819,14.4643086 0.441136651,14.9138268 0.77027028,15.2431961 C1.09856813,15.571729 1.54108393,15.753849 2.00275862,15.749927 L21.9972414,15.749927 Z M21.996203,16.249927 C21.9958359,16.249924 21.9954688,16.249921 21.9951018,16.2499178 L21.9972414,16.249927 L21.996203,16.249927 Z"
                id="shape"
                strokeOpacity="0.2"
                stroke="#000000"
                strokeWidth="0.5"
                fill="#FFFFFF"></path>
              <path
                d="M12.6124138,15.9999283 L21.9972414,15.9999283 C22.5240217,16.0043364 23.0309756,15.7992919 23.4065697,15.4299059 C23.7821638,15.06052 23.9956285,14.5570537 24,14.0302731 L24,11.6716524 C20.4561668,13.7059622 16.6127929,15.1667795 12.6124138,15.9999283 L12.6124138,15.9999283 Z"
                id="shape"
                fill="#F27712"></path>
              <path
                d="M23.1724138,9.29647999 L22.32,9.29647999 L21.36,8.03027309 L21.2689655,8.03027309 L21.2689655,9.29647999 L20.5737931,9.29647999 L20.5737931,6.1516524 L21.6,6.1516524 C22.4027586,6.1516524 22.8662069,6.48268688 22.8662069,7.07854895 C22.8662069,7.56682481 22.5765517,7.88130757 22.0551724,7.98061792 L23.1724138,9.29647999 Z M22.1462069,7.10337654 C22.1462069,6.79716964 21.9144828,6.63992826 21.4841379,6.63992826 L21.2689655,6.63992826 L21.2689655,7.5916524 L21.4675862,7.5916524 C21.9144828,7.5916524 22.1462069,7.42613516 22.1462069,7.10337654 L22.1462069,7.10337654 Z M18.1406897,6.1516524 L20.1103448,6.1516524 L20.1103448,6.68130757 L18.8358621,6.68130757 L18.8358621,7.38475585 L20.0606897,7.38475585 L20.0606897,7.92268688 L18.8358621,7.92268688 L18.8358621,8.77510068 L20.1103448,8.77510068 L20.1103448,9.30475585 L18.1406897,9.30475585 L18.1406897,6.1516524 Z M15.9062069,9.37923861 L14.4,6.14337654 L15.1613793,6.14337654 L16.1131034,8.26199723 L17.0731034,6.14337654 L17.817931,6.14337654 L16.2951724,9.37923861 L15.9227586,9.37923861 L15.9062069,9.37923861 Z M9.60827586,9.37096274 C8.54896552,9.37096274 7.72137931,8.65096274 7.72137931,7.71579033 C7.72137931,6.8054455 8.56551724,6.06889378 9.62482759,6.06889378 C9.92275862,6.06889378 10.1710345,6.12682481 10.4772414,6.25923861 L10.4772414,6.98751447 C10.2453534,6.75969251 9.93335245,6.63192067 9.60827586,6.6316524 C8.9462069,6.6316524 8.44137931,7.1116524 8.44137931,7.71579033 C8.44137931,8.35303171 8.93793103,8.80820412 9.64137931,8.80820412 C9.95586207,8.80820412 10.1958621,8.70889378 10.4772414,8.46061792 L10.4772414,9.18889378 C10.1627586,9.32130757 9.89793103,9.37096274 9.60827586,9.37096274 L9.60827586,9.37096274 Z M7.5062069,8.33647999 C7.5062069,8.94889378 7.00137931,9.37096274 6.27310345,9.37096274 C5.74344828,9.37096274 5.36275862,9.18889378 5.04,8.77510068 L5.49517241,8.38613516 C5.65241379,8.66751447 5.91724138,8.80820412 6.24827586,8.80820412 C6.56275862,8.80820412 6.7862069,8.6178593 6.7862069,8.36958343 C6.7862069,8.22889378 6.72,8.12130757 6.57931034,8.03854895 C6.42504922,7.96369158 6.26441119,7.90275992 6.09931034,7.85647999 C5.44551724,7.64958343 5.22206897,7.42613516 5.22206897,6.98751447 C5.22206897,6.47441102 5.70206897,6.0854455 6.33103448,6.0854455 C6.72827586,6.0854455 7.08413793,6.20958343 7.38206897,6.44130757 L7.01793103,6.85510068 C6.87360928,6.69688076 6.66932728,6.60675635 6.45517241,6.60682481 C6.15724138,6.60682481 5.94206897,6.75579033 5.94206897,6.95441102 C5.94206897,7.11992826 6.0662069,7.21096274 6.48,7.3516524 C7.27448276,7.59992826 7.5062069,7.8316524 7.5062069,8.34475585 L7.5062069,8.33647999 Z M4.08827586,6.1516524 L4.78344828,6.1516524 L4.78344828,9.30475585 L4.08827586,9.30475585 L4.08827586,6.1516524 Z M1.8537931,9.30475585 L0.827586207,9.30475585 L0.827586207,6.1516524 L1.8537931,6.1516524 C2.97931034,6.1516524 3.75724138,6.79716964 3.75724138,7.72406619 C3.75724138,8.19579033 3.52551724,8.64268688 3.12,8.94061792 C2.77241379,9.18889378 2.38344828,9.30475585 1.84551724,9.30475585 L1.8537931,9.30475585 Z M2.66482759,6.9378593 C2.43310345,6.75579033 2.16827586,6.68958343 1.71310345,6.68958343 L1.52275862,6.68958343 L1.52275862,8.77510068 L1.71310345,8.77510068 C2.16,8.77510068 2.44137931,8.69234206 2.66482759,8.52682481 C2.90482759,8.32820412 3.04551724,8.03027309 3.04551724,7.72406619 C3.04551724,7.4178593 2.90482759,7.12820412 2.66482759,6.9378593 Z"
                id="shape"
                fill="#000000"></path>
              <path
                d="M12.4137931,6.06889378 C11.5034483,6.06889378 10.7586207,6.79716964 10.7586207,7.69923861 C10.7586207,8.65923861 11.4703448,9.37923861 12.4137931,9.37923861 C13.3406897,9.37923861 14.0689655,8.65096274 14.0689655,7.72406619 C14.0689655,6.79716964 13.3489655,6.06889378 12.4137931,6.06889378 Z"
                id="shape"
                fill="#F27712"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const DinersClubIcon = (
  <svg width="36px" height="24px" viewBox="0 0 24 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="319" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="New-Icons" transform="translate(-320.000000, -280.000000)" fillRule="nonzero">
        <g id="Card-Brands" transform="translate(40.000000, 200.000000)">
          <g id="Color" transform="translate(0.000000, 80.000000)">
            <g id="Diners-Club" transform="translate(280.000000, 0.000000)">
              <path
                d="M21.9972414,15.749927 L21.999381,15.7499362 C22.9544683,15.7581106 23.73806,14.9772525 23.75,14.0041555 L23.7500083,2.00630219 C23.7461702,1.53568921 23.5588633,1.08617106 23.2297297,0.756801782 C22.9014319,0.428268884 22.4589161,0.246148853 21.9972414,0.250070854 L2.00063,0.250061791 C1.54108393,0.246148853 1.09856813,0.428268884 0.77027028,0.756801782 C0.441136651,1.08617106 0.253829819,1.53568921 0.25,2.00426336 L0.249991686,13.9936957 C0.253829819,14.4643086 0.441136651,14.9138268 0.77027028,15.2431961 C1.09856813,15.571729 1.54108393,15.753849 2.00275862,15.749927 L21.9972414,15.749927 Z M21.996203,16.249927 C21.9958359,16.249924 21.9954688,16.249921 21.9951018,16.2499178 L21.9972414,16.249927 L21.996203,16.249927 Z"
                id="shape"
                strokeOpacity="0.2"
                stroke="#000000"
                strokeWidth="0.5"
                fill="#FFFFFF"></path>
              <path
                d="M10.0021142,2.05179033 L10.0021142,2.03579033 L14.0021142,2.03579033 L14.0021142,2.05179033 C17.1375481,2.28122918 19.5642283,4.89197286 19.5642283,8.03579033 C19.5642283,11.1796078 17.1375481,13.7903515 14.0021142,14.0197903 L14.0021142,14.0357903 L10.0021142,14.0357903 L10.0021142,14.0197903 C6.86668021,13.7903515 4.44,11.1796078 4.44,8.03579033 C4.44,4.89197286 6.86668021,2.28122918 10.0021142,2.05179033 Z"
                id="shape"
                fill="#0165AC"></path>
              <path
                d="M11.6021142,11.4277903 C13.0374002,10.9175027 13.9961556,9.55908923 13.9961556,8.03579033 C13.9961556,6.51249143 13.0374002,5.15407792 11.6021142,4.64379033 L11.6021142,11.4277903 L11.6021142,11.4277903 Z M9.20211417,4.64379033 C7.76682809,5.15407792 6.80807271,6.51249143 6.80807271,8.03579033 C6.80807271,9.55908923 7.76682809,10.9175027 9.20211417,11.4277903 L9.20211417,4.64379033 L9.20211417,4.64379033 Z M10.4021142,13.2357903 C7.53023347,13.2357903 5.20211417,10.907671 5.20211417,8.03579033 C5.20211417,5.16390963 7.53023347,2.83579033 10.4021142,2.83579033 C13.2739949,2.83579033 15.6021142,5.16390963 15.6021142,8.03579033 C15.6021142,10.907671 13.2739949,13.2357903 10.4021142,13.2357903 Z"
                id="shape"
                fill="#FFFFFF"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const JCBIcon = (
  <svg height="24" viewBox="0 0 23 16" width="36" xmlns="http://www.w3.org/2000/svg">
    <g fill="none">
      <path
        d="m.20535714 16h4.51785715c1.0278125 0 2.25892857-1.1946667 2.25892857-2.1333333v-13.8666667h-4.51785715c-1.0278125 0-2.25892857 1.19466667-2.25892857 3.2z"
        fill="#047ab1"
      />
      <path
        d="m2.76924107 10.816c-.86733559.0001606-1.73039558-.1147397-2.56388393-.3413333v-1.17333337c.64678874.37770431 1.38610045.59084099 2.14598215.61866667.8696875 0 1.35535714-.576 1.35535714-1.36533333v-3.22133334h2.14598214v3.22133334c0 1.25866666-.70026786 2.26133333-3.0834375 2.26133333z"
        fill="#fff"
      />
      <path
        d="m8.11160714 16h4.51785716c1.0278125 0 2.2589286-1.1946667 2.2589286-2.1333333v-13.8666667h-4.5178572c-1.02781249 0-2.25892856 1.19466667-2.25892856 3.2z"
        fill="#d42d06"
      />
      <path
        d="m8.11160714 6.08c.65508929-.59733333 1.78455357-.97066667 3.61428576-.88533333.9939285.04266666 2.0330357.32 2.0330357.32v1.184c-.5943231-.3394747-1.2623758-.54734656-1.9539732-.608-1.3892411-.11733334-2.23633933.61866666-2.23633933 1.90933333s.84709823 2.0266667 2.23633933 1.92c.6920185-.06606555 1.3596342-.27744592 1.9539732-.61866667v1.17333337s-1.0391072.288-2.0330357.3306666c-1.82973219.0853334-2.95919647-.288-3.61428576-.8853333z"
        fill="#fff"
      />
      <path
        d="m16.0178571 16h4.5178572c1.0278125 0 2.2589286-1.1946667 2.2589286-2.1333333v-13.8666667h-4.5178572c-1.0278125 0-2.2589286 1.19466667-2.2589286 3.2z"
        fill="#67b637"
      />
      <path
        d="m21.6651786 9.28c0 .8533333-.7002679 1.3866667-1.6377232 1.3866667h-4.0095983v-5.33333337h3.6481697l.2597768.01066667c.8245089.04266667 1.4344196.50133333 1.4344196 1.29066667 0 .61866666-.4179018 1.152-1.1746428 1.28v.032c.8358035.05333333 1.4795982.55466666 1.4795982 1.33333333zm-2.880134-3.104c-.0486104-.00686658-.0976798-.01043129-.1468303-.01066667h-1.3553572v1.344h1.5021875c.2823661-.064.5195536-.30933333.5195536-.672 0-.36266666-.2371875-.608-.5195536-.66133333zm.1694197 2.176c-.059755-.00886168-.1202559-.01243275-.1807143-.01066667h-1.4908929v1.46133334h1.4908929l.1807143-.02133334c.2823661-.064.5195536-.34133333.5195536-.71466666 0-.37333334-.2258929-.64-.5195536-.71466667z"
        fill="#fff"
      />
    </g>
  </svg>
);

export const UnionPayIcon = (
  <svg height="24" viewBox="0 0 24 16" width="36" xmlns="http://www.w3.org/2000/svg">
    <g fill="none">
      <path
        d="m4.54588254.00006676h5.79377466c.8087588 0 1.3117793.72566459 1.1231113 1.61890981l-2.69741608 12.74856503c-.19036262.8901361-1.00010994 1.6164225-1.80943362 1.6164225h-5.79320976c-.80762905 0-1.31177937-.7262864-1.12311135-1.6164225l2.69854581-12.74856503c.18866803-.89324522.9979917-1.61890981 1.80773904-1.61890981"
        fill="#dd2423"
      />
      <path
        d="m9.85756516.00006676h6.66269264c.8086174 0 .4439911.72566459.2537697 1.61890981l-2.6969924 12.74856503c-.1892329.8901361-.1302036 1.6164225-.9405158 1.6164225h-6.66269248c-.81031221 0-1.31177939-.7262864-1.12141672-1.6164225l2.69685116-12.74856503c.19149238-.89324522.99912144-1.61890981 1.8083039-1.61890981"
        fill="#16315e"
      />
      <path
        d="m16.2559813.00006676h5.7937745c.8098886 0 1.3129092.72566459 1.1226878 1.61890981l-2.6969924 12.74856503c-.1903626.8901361-1.0006749 1.6164225-1.8104222 1.6164225h-5.7910915c-.8103122 0-1.3129091-.7262864-1.1231113-1.6164225l2.697416-12.74856503c.1886681-.89324522.9974268-1.61890981 1.8077391-1.61890981"
        fill="#036862"
      />
      <path
        d="m6.05901135 4.08561434c-.59580116.00668457-.77175951 0-.8279645-.01461278-.02160646.11301588-.42365577 2.15460824-.42478553 2.15631824-.08656699.4130443-.14955043.7074763-.36349659.89759795-.12144798.1105286-.26323144.1638497-.42760986.1638497-.26421996 0-.41814822-.1444178-.44399122-.41832975l-.00494264-.09405035s.08049458-.55326485.08049458-.55637395c0 0 .42196112-1.86048711.49751306-2.10641713.00395412-.01399096.00508387-.02129736.00607239-.02798193-.82132725.00792821-.9669236 0-.97695012-.01461278-.00550753.02005371-.025843.13540142-.025843.13540142l-.43085788 2.09693437-.03699927.1778407-.07159782.5817131c0 .1725552.03078565.31339755.09207452.4324762.19629382.37760055.75622549.4341862 1.07297875.4341862.40812169 0 .79096525-.09544945 1.04967767-.26971465.44907509-.2921002.56656897-.74867195.67135315-1.15440985l.04857917-.20815445s.43467082-1.93230737.5085281-2.18367833c.00282441-.01399096.00395413-.02129736.00776704-.02798193zm1.47893982 1.55881086c-.10478422 0-.29627659.0279819-.46828081.12078865-.0624186.0352883-.12144796.07601755-.18372539.11659135l.056205-.22338905-.03078563-.03762015c-.36476761.08130305-.44639193.0921849-.78333945.14441785l-.02824374.0206755c-.03911752.3570805-.07385733.6255515-.21888878 1.32743145-.05521646.25867735-.11255121.519842-.17002718.7778975l.01553403.03280105c.34527946-.0200537.45006363-.0200537.75015309-.0146128l.02428961-.0290701c.03812903-.21499445.04307165-.2653619.12752039-.70079175.03968242-.20644445.1224365-.66006255.16324868-.8215804.07498704-.038242.14898558-.07586215.21959486-.07586215.16819135 0 .14771465.1615179.14121858.22587635-.00720213.1080413-.06849101.4609245-.13133325.76390655l-.04194194.19556255c-.02923223.14441785-.06128888.2847938-.09052111.427968l.01270966.02860375c.34033679-.0200537.44413246-.0200537.73476028-.0146128l.0341749-.0290701c.0525333-.3357831.06792611-.42563615.16113038-.9145426l.04688457-.22463265c.09108601-.43962715.13684082-.6625498.06792616-.8441214-.07286879-.2034908-.24769738-.2526146-.40826291-.2526146zm1.65214439.4602871c-.18090101.038242-.29627659.0637366-.41094606.08021485-.11368097.02005375-.22453757.038242-.39936616.06498025l-.01383941.0138355-.01270966.01103735c-.01821719.14332965-.0309269.26722735-.05507525.41288885-.02047669.150636-.05196844.3217921-.10323077.56772215-.03968243.18825615-.06015913.25385825-.08275412.32008215-.0220301.06622385-.04631967.1305823-.09094476.31572935l.01045019.0171001.00875554.01570095c.1633899-.00855005.27029237-.0146128.38016043-.01570095.10972684-.00435275.22340776 0 .39936611.00108815l.01539286-.0138355.01652257-.0152346c.02541932-.1669588.02923224-.21188535.04476626-.29334385.01539282-.0873658.04194194-.20830985.10704369-.53134565.03078568-.1517242.06510179-.30298205.09701718-.4578154.03318641-.1542115.06792612-.30609115.10097127-.45781535l-.00494263-.0183437zm.00385525-.620608c-.1643784-.10679765-.45288796-.07290845-.64706354.0746185-.19361063.14457325-.21564072.34977405-.05182718.4579708.16155403.10384405.45119334.0729085.64367421-.0758621.19318708-.14768235.21733543-.3510177.05521651-.4567272zm.99410809 2.473369c.3325698 0 .6734715-.1008904.9300657-.400297.1974235-.2428209.2879446-.60409865.3192952-.7528692.1021011-.4931037.0225949-.7233328-.0772466-.8635533-.1516687-.21375085-.4197016-.28230655-.697761-.28230655-.1672028 0-.5654392.01818825-.87654364.33391765-.22340786.22774175-.32663863.5367866-.38891601.83308405-.06284224.3018939-.13514621.84536505.31887154 1.0476122.14008884.0662239.34203141.08441215.47223481.08441215zm-.0259841-1.10948335c.0766817-.3734032.1672028-.6868008.3982364-.6868008.1810422 0 .1941755.23318275.1136809.6078296-.0144042.0831685-.0804945.3923688-.1698859.5240393-.0624186.09715945-.1362759.15607695-.2179003.15607695-.0242896 0-.1687562 0-.1710157-.23613635-.0011297-.11659135.0204767-.23567.0468846-.3650087zm2.1066988 1.06146325.0259841-.0290701c.0368581-.21499445.0429305-.2655174.1245549-.70079175.0408121-.20644445.1252608-.66006255.1649433-.82158045.0751282-.0383974.1478558-.07601755.2207245-.07601755.1670616 0 .1467262.1615179.140089.2258763-.0060725.1081968-.0673613.4609245-.1313334.76390655l-.0396824.1955626c-.030362.14457325-.0634071.2847938-.0926394.42812345l.0127097.02860375c.3414665-.02005375.441308-.02005375.7336305-.0146128l.0353047-.0290701c.0512623-.33593855.0651017-.42579165.1611304-.9145426l.0457548-.2247881c.0915096-.43962715.1378292-.66239435.0700444-.84396595-.0749871-.2034908-.2509454-.2526146-.4092515-.2526146-.1049254 0-.2974063.02782645-.468422.12078865-.0611476.0352883-.1224365.0758621-.1825956.11659135l.0523921-.22338905-.0281025-.0377756c-.3646263.0814585-.4479453.09234035-.7844692.1445733l-.025843.0206755c-.0408122.35708045-.0739986.62539605-.21903 1.32743145-.0552164.25867735-.1125512.51984195-.1698859.7778975l.0153928.03280105c.3458442-.02005375.4490751-.02005375.7485997-.0146128zm2.5088186.01453505c.0214652-.1153477.1489856-.7990394.1501153-.7990394 0 0 .1085971-.50165375.1152345-.519842 0 0 .0341748-.0522329.0683497-.07290845h.0502738c.4743532 0 1.0099953 0 1.4298381-.3399804.2856852-.2331827.4809905-.57751585.5681223-.99600105.022595-.1026004.0392588-.22463269.0392588-.34666496 0-.16027425-.0292322-.3188385-.1136809-.44273624-.2140874-.32972035-.6404262-.3357831-1.132573-.33827039-.0015534 0-.2426136.00248729-.2426136.00248729-.629976.00855003-.8826161.00606275-.9864117-.00792821-.0087556.05052291-.0252782.14037599-.0252782.14037599s-.2256673 1.15130077-.2256673 1.15316622c0 0-.5400198 2.4477966-.5654392 2.5631443.5500464-.00730635.7755725-.00730635.8704714.0041973zm.4181482-2.0451678s.2399304-1.14896892.2388007-1.14461618l.0077669-.05891749.0033893-.04492654.0958874.01088185s.4948299.046792.5064099.04803565c.1953052.0831685.2757998.29754113.2195948.57736036-.0512623.2557237-.2019425.4707182-.3955532.5745622-.1594358.0879876-.3547411.095294-.5559775.095294h-.1302035zm1.4938667.99045135c-.0634072.2975411-.136276.8410123.3154822 1.0347094.1440429.0674675.2731167.0875212.4043088.08021485.1385355-.00823915.2669031-.08472305.3858092-.1947853-.0107326.04523745-.0214652.0904749-.0321978.1358678l.0204766.0290701c.324944-.01507915.4257741-.01507915.7778319-.0121255l.0319154-.0267383c.0514036-.332674.0998416-.65570975.2334344-1.2921431.0651017-.30484755.1300622-.6067414.1968587-.9103453l-.0104501-.03342285c-.3634967.0741521-.4606551.09000855-.8103124.1445733l-.026549.0237846c-.0035305.0309356-.0072021.0606275-.0105914.09031945-.0543692-.0966931-.1331691-.17923975-.2547583-.2306954-.1554817-.0673121-.5206729.01943185-.8346018.33407305-.2205834.2246327-.3264973.53243385-.3866564.8276432zm.7634275.01818825c.0778115-.3667187.1672028-.67700715.3988014-.67700715.1464436 0 .2235489.14877055.2078737.40247335-.0124272.06327025-.025843.1299605-.0418008.20535625-.0231597.10897405-.0482967.21701535-.0727275.32521215-.0248545.07399665-.0538043.143796-.0855784.1902771-.0595943.09296215-.2013777.150636-.2830021.150636-.0231599 0-.1660731 0-.1710157-.23193905-.0011298-.11550315.0204767-.23442635.0474494-.36500865zm3.9866711-1.21085565-.0281024-.0352883c-.3596838.08021485-.4247856.09296215-.755237.142086l-.0242897.02673825c-.0011296.00435275-.0021182.01103735-.0038128.0171001l-.0011298-.00606275c-.2460027.6247742-.2388006.4899946-.4390485.98185465-.0011298-.02238555-.0011298-.0363765-.0022595-.06016115l-.0501327-1.0662668-.0314917-.0352883c-.3767711.08021485-.3856679.09296215-.7336305.142086l-.0271139.02673825c-.003813.01274735-.003813.0267383-.0060724.0419729l.0022594.00544095c.0434954.2446864.0330452.19012165.0766818.5762722.0203354.1894998.0474494.3800878.0677848.5672558.0343162.3132421.0535219.4674536.0954638.94547815-.2349878.4268798-.2906279.5883977-.51686.9630446l.0015534.0037309-.1592946.27733195c-.0182171.0292256-.0347397.0492793-.0578996.05782935-.0254193.0138355-.0584644.01632275-.1043605.01632275h-.0882616l-.131192.4803564.4500635.00855005c.26422-.00124365.4302931-.1372669.5196844-.32008215l.283002-.53383295h-.004519l.0297972-.03762015c.1903626-.4511308 1.6384179-3.1855867 1.6384179-3.1855867zm-4.7501128 6.3087581h-.1909276l.7066579-2.57293795h.2344228l.0744221-.265051.0072022.29474295c-.0087556.1821934.121448.3437113.4634794.31697305h.3955532l.1361347-.49543555h-.1488443c-.0855785 0-.1252609-.02378465-.1203182-.0747739l-.0072022-.299873h-.7325008v.00155455c-.2368235.00544095-.9440462.0250283-1.0872418.0670012-.1732752.0491238-.3558709.1936971-.3558709.1936971l.071739-.26536195h-.6851925l-.1427719.52652655-.7161194 2.61226815h-.1389591l-.136276.4918601h1.3647364l-.0457548.1640051h.6724828l.0446251-.1640051h.1886681zm-.5599316-2.0501423c-.1097268.03342285-.313929.1347796-.313929.1347796l.1816071-.65757525h.5443977l-.1313333.47911275s-.1681914.01088185-.2807425.0436829zm.0104502.9394154s-.1710158.0236292-.283567.0516111c-.1108566.0369984-.3187303.1535897-.3187303.1535897l.1875382-.6843135h.5472221zm-.3050322 1.1167897h-.5460922l.158306-.5775158h.5443976zm1.315112-1.5959024h.7871525l-.1131162.4032506h-.7976024l-.1197535.4408708h.6979023l-.5284398.8190931c-.0369994.0601612-.0701858.0814585-.1070437.0984031-.0369994.0206755-.0855785.0449265-.1417835.0449265h-.1936107l-.133028.4828437h.5064098c.2632315 0 .4187131-.131826.5335239-.3048476l.3623669-.5459584.0778115.5543531c.0165225.1038439.0843074.1646269.1302034.1882561.0506975.0279819.1030897.0760176.1770882.0831685.0793648.0037309.1366995.0066846.1748285.0066846h.2488272l.1494092-.5403621h-.0981469c-.0563463 0-.1533633-.0104155-.1698859-.0298474-.0165226-.0236292-.0165226-.0600057-.0254194-.1153477l-.0789412-.5555967h-.3232494l.1417836-.1857688h.796049l.1224365-.4408708h-.7370197l.1148107-.4032506h.7347603l.1362759-.497301h-2.1905826zm-6.6483163 1.7081877.1837253-.6728098h.7550958l.1379705-.5004101h-.7558018l.1153756-.4141325h.7385731l.1368408-.4845537h-1.84798632l-.13401641.4845537h.41984283l-.1119863.4141325h-.42097264l-.13952389.5089601h.41970155l-.24487301.8901361c-.03304514.117835.01553408.1627615.04631971.2174817.03149175.0533211.06340718.0886094.13514621.1086631.07399857.0181883.12469597.0290701.19361067.0290701h.8512656l.1516688-.554353-.3773361.0570521c-.0728688 0-.2746701-.0096382-.25264-.0837903zm.0866093-3.22084395-.1913512.38070965c-.0409534.08316845-.0778114.1347796-.1109978.1585642-.0292322.02005375-.0871318.0284483-.1710157.0284483h-.0998415l-.13345158.48704095h.33158128c.1594357 0 .2818722-.0643584.3403368-.09653765.0628422-.0369983.0793647-.0158564.1279439-.0674675l.1119864-.1067977h1.0354146l.1374057-.50709465h-.7579202l.1323219-.2768656zm1.5286064 3.23062205c-.0176524-.027982-.0049427-.0772612.0220301-.1798616l.283002-1.0311339h1.0067472c.1467262-.0023318.25264-.0041973.3215547-.0096382.0739985-.0085501.1544932-.0376202.2421899-.0898531.0905212-.0547202.1368408-.1123941.1759583-.178618.0436366-.0660684.113681-.2106417.1738401-.4335643l.3557296-1.3048905-1.044735.0066846s-.3216959.0522329-.4633381.10990675c-.1429132.06435845-.3471154.2440646-.3471154.2440646l.0943341-.3577023h-.645369l-.9035164 3.29860265c-.0320566.1280949-.0535218.2210571-.0584645.2768655-.0016946.0601612.0689147.1197005.1146695.164627.0540867.0449266.1340164.0376202.2106981.0449266.0806358.0066846.1953053.0108818.3536113.0108818h.4959597l.1522336-.5658567-.4439912.0461702c-.0474494 0-.0817655-.027982-.0960286-.0516111zm.4876277-1.9074346h1.0574447l-.06722.2319391c-.0094616.0054409-.0320566-.0115037-.1396652.0024873h-.9156612zm.2118279-.77789745h1.0663414l-.0766816.27935285s-.5025969-.0054409-.5830915.01088185c-.3541763.06746755-.5610614.27577745-.5610614.27577745zm.802065 1.78653705c-.0087555.0346665-.0225949.0558084-.0419418.0716648-.0214654.0152346-.0562051.0206755-.1080323.0206755h-.1506803l.0088968-.2824619h-.626728l-.0254193 1.380908c-.0009886.0996467.007767.1573206.0739985.2034908.0662315.0576738.2702923.0649802.5449624.0649802h.392729l.1417834-.5168883-.3418902.0206755-.1136809.0073064c-.0155341-.0073064-.030362-.013991-.0468846-.0321792-.0144043-.015701-.0386939-.0060627-.0347398-.1057095l.0026831-.3539713.3585541-.0163228c.1936107 0 .2763648-.0693331.346974-.1354015.0673612-.0632702.0893913-.1360232.1148107-.2344264l.0601592-.3133975h-.4927118z"
        fill="#fefefe"
      />
    </g>
  </svg>
);

export const BillingIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 17.0827L2.5 18.3327V1.66602L3.75 2.91602L5 1.66602L6.25 2.91602L7.5 1.66602L8.75 2.91602L10 1.66602L11.25 2.91602L12.5 1.66602L13.75 2.91602L15 1.66602L16.25 2.91602L17.5 1.66602V18.3327L16.25 17.0827L15 18.3327L13.75 17.0827L12.5 18.3327L11.25 17.0827L10 18.3327L8.75 17.0827L7.5 18.3327L6.25 17.0827L5 18.3327L3.75 17.0827ZM15 5.83268V7.49935H5V5.83268H15ZM5 9.16602V10.8327H15V9.16602H5ZM5 12.4993V14.166H15V12.4993H5Z"
      fill="currentColor"
    />
  </svg>
);

export const ProfileIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 3C11.66 3 13 4.34 13 6C13 7.66 11.66 9 10 9C8.34 9 7 7.66 7 6C7 4.34 8.34 3 10 3ZM10 17.2C7.5 17.2 5.29 15.92 4 13.98C4.03 11.99 8 10.9 10 10.9C11.99 10.9 15.97 11.99 16 13.98C14.71 15.92 12.5 17.2 10 17.2Z"
      fill="currentColor"
    />
  </svg>
);

export const PaymentIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 14V6C19 4.9 18.1 4 17 4H3C1.9 4 1 4.9 1 6V14C1 15.1 1.9 16 3 16H17C18.1 16 19 15.1 19 14ZM10 13C8.34 13 7 11.66 7 10C7 8.34 8.34 7 10 7C11.66 7 13 8.34 13 10C13 11.66 11.66 13 10 13ZM23 7V18C23 19.1 22.1 20 21 20H4V18H21V7H23Z"
      fill="currentColor"
    />
  </svg>
);

export const PasswordIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83334 5C8.00834 5 9.85833 6.39167 10.5417 8.33333H19.1667V11.6667H17.5V15H14.1667V11.6667H10.5417C9.85833 13.6083 8.00834 15 5.83334 15C3.075 15 0.833336 12.7583 0.833336 10C0.833336 7.24167 3.075 5 5.83334 5ZM4.16667 10C4.16667 10.9167 4.91667 11.6667 5.83334 11.6667C6.75 11.6667 7.5 10.9167 7.5 10C7.5 9.08333 6.75 8.33333 5.83334 8.33333C4.91667 8.33333 4.16667 9.08333 4.16667 10Z"
      fill="currentColor"
    />
  </svg>
);
